/**
 * @author Max Erekhinskiy <max.erekhinskiy@gmail.com>, Jun 28, 2012 11:51:23 AM
 * @copyright MegaGroup © 2012, megagroup.ru
 */

(function () {
  'use strict';

  var Navigator = Onicon.lib('navigator'),
    Cookie = Onicon.lib('cookie'),
    Colors = Onicon.lib('colors'),
    Dom = Onicon.lib('dom'),
    Widgets = Onicon.lib('widgets'),
    DateSync = Onicon.lib('datesync'),
    Formatter = Onicon.formatter,
    Trigger = Onicon.trigger,
    Transport = Onicon.transport,
    LocalStorage = Onicon.local_storage,
    SessionStorage = Onicon.session_storage,
    $ = Onicon.$,

    core = {

      DEBUG: true,
      RESET_LIMIT: 100,

      // Кол-во авторизаций (успешных или ошибочных за время работы скрипта)
      auth_num: 0,
      auth_channels: 0,

      // Кол-во зафейленых соединений при работающем сервере, не включая -163.
      // Используется для перехода на проксю.
      failed_connections_with_ok_state: 0,

      // Был ли ответ на авторизацию (102, -102, а также -163 - сервер перегружен), используется только для
      // переключения на проксю
      was_ws_response: false,

      // если данный флаг выставлен в true, то после connectionClose оникон вновь запустит метод .run()
      // проверка происходит до метода флага stop (см. ниже)
      rerun: null,

      // В случае остановки скрипта тут будет причина
      stop: null,

      // ссылка на сайтовую кнопку, если она размещена на сайте
      site_button: null,

      /* Режимы: (1 - всегда показывать, 2 - только когда операторы онлайн, 3 - никогда не показывать)
       * при этом есть тонкость связанная с дополнительной кнопкой, если она задана, то Закладка (Bookmark) не должна отображаться
       * вообще никогда в режимах 2 и 3
       */
      visibility_mode: null,

      // Отображение кнопки на мобильных у стройствах
      mobile_enabled: true,

      /* форсированное разрешение на отображение панели чата (не закладки). Напр. после нажатия на доп кнопку, и пока нет
       * ни одного входящего сообщения от операторов.
       */
      panel_show_allow: false,

      // Режим работы в новом окне, т.е. работает ли текущий клиент в окне
      isolated: false,

      // Сюда будет сохранен ключ для изолировнного режима
      isolated_sign: null,

      // Глобальный флаг для всего потсетителя (всех его коннектов)
      isolated_mode: null,

      isolated_window: null,

      live_forms_applied: false,
      live_forms_config: {},

      user_id: null,
      user_hash: null,
      direct_user: null,
      pinger: null,

      panel_id: 'panel',
      bookmark_id: 'bookmark',
      bookmark_images: null,
      inc: 0,

      id_prefix: 'onicon-' + (+new Date()) + '-',

      channels: {
        chat: null,
        site: null
      },

      TEXTAREA_FOCUSED: false,
      CAN_SEND_TYPING_NOTIFICATION: true,
      typing_display_timeout: null,

      RELEASE_SENDING_TIME: 5000,
      sending_lock_release_timeout: null,

      SHOW_PANEL: 1,
      SHOW_BOOKMARK: 2,

      SOUNDS_ON: false,

      current_state: 0, // [1] - online-active, [2] - online-disabled, [-1] - offline-message, [-2] - offline-history
      last_state: 0,
      STATE_NULL: 0,
      STATE_ONLINE: 1,
      STATE_OFFLINE: -1,

      first_panel_show: false,

      site_button_id: null,
      site_buttons: [],
      main_title: '', // Must be replaced by localization[<lang>].main_title on init()

      show_server_down: false,
      site_info: null,
      docInfo: null,

      isMovingPanel: false,
      repositioning: 1,

      panel_dim: null,
      panel_dim_default: {
        width: 280,
        height: 50,
        pos_x: 'right',
        pos_y: 'bottom',
        margin_x: 0,
        margin_y: 0,
        max_height: 250
      },

      panel_dim_limits: {
        min_width: 280,
        min_height: 50
      },

      hash_watcher: null,
      hash_watcher_last_url: null,

      favicon_blinker_interval: null,

      site_domain: null,

      session_start: 0,

      region: '',

      // Список "использованных" за текущее время работы JS авторассылок
      sended_autosends: {},

      // Список принятых авторассылок за все время (отстраивается по messages)
      autosends_log: {},
      // ID последнего принятого сообщения
      last_message_id: null,
      // История, которая была сохранена где либо (напр.: localStorage),
      // будет использована после авторизации и только при пустом messages с сервера
      messages_history: [],

      yandex_metrika: {
        yandex_metrika_key: null,
        already_included: false // Счетчик уже вставлен
      },

      // Есть ли в истории сообщения, отправленные "руками", а не автоматически
      has_manual_messages: false,

      // Копирайт скрыт
      no_copyright: null,

      vk_data: null,

      first_switch: true,

      fingerprint: null,

      hole: null,

      countryList: {
        ru: 'россия',
        by: 'республика беларусь',
        ua: 'украина',
        kz: 'казахстан',
        uz: 'узбекистан',
        de: 'германия',
        gb: 'великобритания',
        us: 'сша',
        az: 'азербайджан',
        ge: 'грузия',
        tr: 'турция',
        md: 'молдова'
      },

      viewCallbackButton: false, // отвечает за отображение кнопочки на сайте
      canCallto: false, // отвечает за включение функции быстрого звонка
      canCallback: false,

      // custom Scroller Init
      scrollBar: {
        init: function (scrollArea) {
          var scrollTool = Dom.createNode('div', null, 'onicon_chat-vertical-scroll'),
            scrollRunner = Dom.createNode('div', null, 'onicon_chat-scroll-runner'),
            scrollRoll = Dom.elementChildren(scrollArea)[0],
            scrollState = null;

          // Цвет бегунка
          scrollRunner.style.backgroundColor = core.site_info.colors[0];

          scrollTool.appendChild(scrollRunner);
          scrollArea.appendChild(scrollTool);

          Dom.attachEvent('mousedown', function (e) {
            scrollState = {mouse_y: e.clientY};
            e.preventDefault && e.preventDefault();
            return false;
          }, scrollRunner);

          Dom.attachEvent('mouseup', function () {
            scrollState = false;
          });

          Dom.attachEvent('mousemove', function (e) {
            if (scrollState) {
              var topPos = scrollArea.scrollTop,
                ratio = scrollArea.offsetHeight / scrollRoll.offsetHeight,
                dy = e.clientY - scrollState.mouse_y;

              scrollState.mouse_y = e.clientY;
              if (scrollRunner.style.top + dy > scrollArea.offsetHeight) {
                dy = 0;
              }
              if (scrollRunner.style.top - dy < 0) {
                dy = 0;
              }
              scrollArea.scrollTop += dy / ratio;
              e.preventDefault && e.preventDefault();
              return false;
            }
          });

          Dom.attachEvent('scroll', this.update, scrollArea);
          this.update.call(scrollArea);
        },

        update: function () {
          var scrollArea = this,
            scrollTool = scrollArea.childNodes[3],
            scrollRunner = scrollTool.childNodes[0],
            scrollRoll = scrollArea.childNodes[1],
            topPos = scrollArea.scrollTop;

          // Onicon.error(scrollArea.childNodes);
          // Onicon.error(scrollArea, scrollTool, scrollRunner, scrollRoll);

          scrollTool.style.top = topPos + 'px';
          scrollTool.style.bottom = (-topPos) + 'px';

          var ratio = scrollArea.offsetHeight / scrollRoll.offsetHeight;

          if (ratio < 1) {
            scrollTool.style.display = 'block';
            scrollArea.style.paddingRight = '15px';
            scrollRunner.style.height = (ratio * scrollArea.offsetHeight) + 'px';
            scrollRunner.style.top = (ratio * topPos) + 'px'
          } else {
            //scrollTool.style.display = 'none';
            scrollArea.style.paddingRight = '17px';
          }
        }
      },


      /**
       * Загружает значения положения и размеров панельки из cookie (если положение или размер изменялись посетителем), или
       * из настроек для сайта (кроме ширины и высоты, которые просто имеют системный default), если значения не менялись.
       */
      loadPanelDim: function () {
        if (core.isolated) return;

        if (!core.panel_dim) {
          core.panel_dim = {};
        }

        var cookie_value = Cookie.get(Onicon.COOKIE_PREFIX + 'panel_position'),
          inf = core.site_info;

        var params = [];
        if (cookie_value) {
          Onicon.log('[core.visitor:loadPanelDim] Set data from cookie');
          params = JSON.parse(cookie_value.replace(/^[^\[]|[^\]]$/g, '').replace(/\\?'/g, '"'));
        } else {
          Onicon.log('[core.visitor:loadPanelDim] Set data from site params and default values');
          params = [inf.panel_position[0], inf.panel_position[1], inf.panel_margin[0], inf.panel_margin[1], core.panel_dim_default.width, core.panel_dim_default.height];
        }

        core.panel_dim.pos_x = params[0];
        core.panel_dim.pos_y = params[1];
        core.panel_dim.margin_x = params[2];
        core.panel_dim.margin_y = params[3];
        core.panel_dim.width = params[4];
        core.panel_dim.height = params[5];

        Onicon.log('[core.visitor:loadPanelDim] Result: ', core.panel_dim);
      },

      applyPanelDim: function (make) {
        make = make ? make : false;
        if (core.isolated) {
          return;
        }

        if (!core.panel_dim) {
          core.loadPanelDim();
        }

        var dim = core.panel_dim;

        var panel = core.getById('panel'),
          area = core.getById('message-area');

        // panel.className = panel.className; // force reflow in ie
        var dynamic_height = parseInt(area.offsetHeight);

        if (core.current_state == core.STATE_OFFLINE) {
          core.setPanelHeight(); // dim.height
        } else {
          if (dynamic_height) {
            if (dynamic_height < core.panel_dim_default.max_height) {
              core.setPanelHeight(dynamic_height);
            } else {
              core.setPanelHeight(core.panel_dim_default.max_height);
            }
          }
          if (make) {
            core.setPanelHeight(dim.height); // dim.height
          }
        }

        core.setPanelWidth(dim.width);

        core.last_dim = {
          width: dim.width,
          height: dim.height
        };

        Dom.positionFixed(panel, dim.pos_x, dim.pos_y, dim.margin_x, dim.margin_y);

        //if (core.site_info.callback_enabled) {
        //    Dom.positionFixed(
        //        core.getById('float_button_wrap'),
        //        dim.pos_x,
        //        dim.pos_y,
        //        dim.margin_x - 184,
        //        dim.margin_y + 30);
        //}

        Cookie.set(Onicon.COOKIE_PREFIX + 'panel_position', JSON.stringify([dim.pos_x, dim.pos_y, dim.margin_x, dim.margin_y,
          dim.width, dim.height]).replace(/"/g, "'"), Onicon.panel_pos_cookie_ttl);
      },

      chatControlsPanelMove: function () {
        var panel_top = Dom.cssInt(this.getById('panel'), 'top');
        this.getById('chat-controls-panel').style.top = (panel_top >= -14 ? 14 : 14 + (-1 * (panel_top + 14))) + 'px';
      },

      _getById: function (id) {
        return $('#' + core.id_prefix + id);
      },

      getById: function (id) {
        return document.getElementById(core.id_prefix + id);
      },

      _createId: function (id) {
        return '#' + core.id_prefix + id
      },

      createId: function (id) {
        return core.id_prefix + id;
      },

      init: function () {
        core.isolated = !!(Onicon.LOADER_PARAMS.user_id && Onicon.LOADER_PARAMS.user_hash);
        if (core.isolated) {
          core.id_prefix = 'isolated-';
        }

        if (Onicon.LOADER_PARAMS.lang && Onicon.i18n[Onicon.LOADER_PARAMS.lang]) {
          core.locale = Onicon.i18n[Onicon.LOADER_PARAMS.lang]
        } else {
          core.locale = Onicon.i18n.ru
        }


        var parser = document.createElement('a');
        parser.href = location.href;

        var demo_site = parser['hostname'].match(/demo-site-(.+).oml.ru/);
        if (demo_site && parser['hash'] == "#new") {
          setTimeout(function () {
            location.hash = '';
          }, 5000);
        }

        // FingerPrint
        //new Onicon.fp2().get(function(result, components){
        //    Onicon.core.fingerprint = result;
        //});

        // Inject Hole
        //core.hole = document.createElement("iframe");
        //document.body.appendChild(core.hole);
        //core.hole.id = 'onicon-hole';
        //core.hole.style.display = "none";
        //core.hole.src = Onicon.URL_STATIC + 'track/hole.html';

        // Remove old chat server state message
        Trigger.bind('connected', function () {
          Dom.removeElement(core.getById('chat-message-server-state'));
        });

        if (!core.isolated) {
          Trigger.bind(Trigger.EV_AUTHORIZED_ONCE, function () {
            core.pagesHistory(true);

            Trigger.bind(Trigger.EV_V_HASH_CHANGED, function () {
              core.pagesHistory(true);
            });
          });
        }

        core.getDocumentInfo();


        if (typeof window.initOnicon == 'function') {
          window.initOnicon.call(Onicon);
        }

        Trigger.execute('onicon-init');
      },

      pagesHistory: function (add) {
        var history_limit = 200;
        var history_key = 'page_history_' + core.user_id;
        var old_history = LocalStorage.get(history_key);

        if (typeof old_history === 'string') {
          try {
            old_history = JSON.parse(old_history);
          } catch (e) {
            old_history = null;
            LocalStorage.remove(history_key);
          }
        }

        if (!old_history) {
          old_history = [];
        }

        if (add) {
          if (old_history.length > history_limit) {
            old_history.splice(0, (old_history.length - history_limit));
          }

          old_history.push({
            time: Math.round(+(new Date()) / 100),	// время по клиенту в секундах
            url: core.docInfo.location				// адрес посещенной страницы
          });
          LocalStorage.set(history_key, old_history);
        }

        return old_history;
      },

      run: function () {
        Onicon.log('[core] Running...');
        var transport = Onicon.transport;
        transport.delayed_send_enabled = false;
        transport.onopen(function () {
          Dom.attachEvent('unload', function () {
            Onicon.log('Unloading page, try to do safe ws close');
            Transport.send({
              flag: Onicon.protocol.CLIENT_CODE_CLOSE_CONNECTION,
              message: 'Please, close my websocket. Page unloading.'
            });
          });
          core.checkAuth();
          Trigger.trigger('onicon-connected');
        });

        transport.onclose(core.connectionClosed);
        transport.onerror(core.connectionError);
        transport.onmessage(core.packet);

        transport.open();
      },

      checkAuth: function () {
        core.user_id = Onicon.LOADER_PARAMS.user_id || Cookie.get(Onicon.COOKIE_PREFIX + 'user_id');
        core.user_hash = Onicon.LOADER_PARAMS.user_hash || Cookie.get(Onicon.COOKIE_PREFIX + 'user_hash');

        Onicon.log('[core] Check auth %s %s', core.user_id, core.user_hash);
        if (!core.user_id || !core.user_hash) {
          core.register();
        } else {
          core.authorize();
        }
      },


      authorize: function () {
        var ls_data = false, last_message_id = null;
        if (LocalStorage.isSupported()) {
          ls_data = LocalStorage.get('onicon_history:' + core.user_id);
          if (ls_data) {
            last_message_id = core.last_message_id = ls_data.last_message_id;
            core.messages_history = ls_data.messages_history ? ls_data.messages_history : [];
            core.autosends_log = ls_data.autosends_log;
          }
        }

        var extra_data = {};
        if (window.Cabinet) extra_data['client'] = window.Cabinet.client;
        if (core.vk_data && core.vk_data[0]) extra_data['vkuser'] = core.vk_data[0];
        var url_params = Onicon.lib('url_parser').parse(window.location.href);
        if (Object.keys(url_params).indexOf('yclid') != -1 || Object.keys(url_params).indexOf('gclid') != -1) {
          core.direct_user = extra_data['url_params'] = url_params;
        }


        if (Cookie.get('roistat_visit')) {
          extra_data['roistat_visit'] = Cookie.get('roistat_visit');
        }

        if (window.onicon_custom_data) {
          extra_data['custom_data'] = window.onicon_custom_data;
        }

        Transport.send({
          flag: Onicon.protocol.CLIENT_CODE_AUTHORIZE,
          user_id: core.user_id,
          user_hash: core.user_hash,
          site_id: Onicon.LOADER_PARAMS.site_id,
          location: core.docInfo.location,
          referrer: core.docInfo.referer,
          agent: window.navigator.userAgent,
          title: core.docInfo.title,
          sign: Onicon.LOADER_PARAMS.sign ? Onicon.LOADER_PARAMS.sign : null,
          isolated_sign: Onicon.LOADER_PARAMS.isolated_sign ? Onicon.LOADER_PARAMS.isolated_sign : null,
          last_message_id: last_message_id,
          extra_data: extra_data,
          wix: Onicon.LOADER_PARAMS.wix ? {mainLocation: document.location.href} : null
        });
      },

      register: function () {
        if (core.isolated) {
          core.stop = 'Register is not available in isolated mode.';
        } else {

          var extra_data = {};
          if (window.Cabinet) extra_data['client'] = window.Cabinet.client;
          if (core.vk_data && core.vk_data[0]) extra_data['vkuser'] = core.vk_data[0];
          var url_params = Onicon.lib('url_parser').parse(window.location.href);
          if (Object.keys(url_params).indexOf('yclid') != -1 || Object.keys(url_params).indexOf('gclid') != -1) {
            core.direct_user = extra_data['url_params'] = url_params;
          }

          if (Cookie.get('roistat_visit')) {
            extra_data['roistat_visit'] = Cookie.get('roistat_visit');
          }

          if (window.onicon_custom_data) {
            extra_data['custom_data'] = window.onicon_custom_data;
          }

          Transport.send({
            flag: Onicon.protocol.CLIENT_CODE_VISITOR_REGISTER,
            site_id: Onicon.LOADER_PARAMS.site_id,
            location: core.docInfo.location,
            title: core.docInfo.title,
            sign: Onicon.LOADER_PARAMS.sign ? Onicon.LOADER_PARAMS.sign : null,
            extra_data: extra_data,
            agent: window.navigator.userAgent,
            wix: Onicon.LOADER_PARAMS.wix ? {mainLocation: document.location.href} : null
          });
        }
      },


      getDocumentInfo: function () {
        core.docInfo = {
          location: document.location.href,
          referer: document.referrer,
          title: document.title
        };

        //Если это Wix, попробуем вытащить данные сайта
        if (Onicon.LOADER_PARAMS.wix && Wix != undefined) {
          Wix.Settings.getSiteInfo(function (siteInfo) {
            core.docInfo.location = "visitor3.loc"; // siteInfo['baseUrl'];
            core.docInfo.referer = "referer.loc"; //siteInfo['referer'];
            core.docInfo.title = "wix_title"; //siteInfo['pageTitle'];
          });
        }
      },

      connectionClosed: function () {
        var time_stamp = +(new Date());

        core.stopPinger();
        Onicon.log('[core] Connection reseted, reset: %s/%s, auth: %s, failed_connects: %s',
          Transport.num_closed, core.RESET_LIMIT, core.auth_num, core.failed_connections_with_ok_state);

        if (core.rerun) {
          Onicon.log('Onicon will be re-runned because of: ' + core.rerun);
          core.rerun = false;
          core.run();
          return;
        }

        if (core.stop) {
          Onicon.log('Onicon has been stoped because of: ', core.stop);
          return;
        }

        var reconnect_after = 700 * Transport.num_closed
          + Dom.rand(100, 1000) * Transport.num_closed;

        Onicon.log('[core] Connection reseted, reconnect after %s milliseconds', reconnect_after);


        setTimeout(function () {

          // Перезапрашиваем хосты сервера
          Onicon.loadHosts();

          // Применяем новые хосты
          Onicon.applyTransport();

          Onicon.loader.action(function () {

            // Получили результат (true, false, empty page or 404)
            // Если сервер работает или только что заработал и небыло хоть какого-то ответа на авторизацию
            if (Onicon.LAST_SERVER_OK > time_stamp && !core.was_ws_response) {

              Onicon.log('[core] Server is running but connection is broken');

              core.failed_connections_with_ok_state++;

              // И мы не в состоянии к нему подключиться по WebSocket N-е количество раз,
              // значит самое время попробовать polling
              if (core.failed_connections_with_ok_state >= Onicon.TRANSPORT_SWITCH_LIMIT
                && Onicon.TRANSPORT_STATE === Onicon.transport_states.WEB_SOCKET) {

                Onicon.log('[core] It is time to try polling mode');

                Cookie.set(Onicon.COOKIE_PREFIX + 'polling_mode', 'enabled',
                  Onicon.polling_mode_cookie_ttl);

                // Подтягиваем недостающие файлы для пуллинга
                Onicon.enablePolling();

                // После того как подтянем снова возвращаемся сюда
                // Но в этот IF мы уже не попадем, т.к. Oncion.TRANSPORT_STATE уже будет равен
                // Onicon.transport_states.POLLING
                Onicon.loader.action(core.connectionClosed);
                return;
              }
            }

            core.systemMessage(core.locale.msg_disconnected, 'server-state');

            if (core.current_state === core.STATE_ONLINE) {
              core.switchPanelState(core.STATE_OFFLINE);
              core.updateOperator();
            } else {

            }

            if (Transport.num_closed === core.RESET_LIMIT) {
              Onicon.log('[core] Connection reseted, reset limit reached: ', core.RESET_LIMIT);
            } else {
              Onicon.loader.action(function () {
                core.was_ws_response = false;
                Transport.open();
              });
            }

            if (window.onhashchange !== undefined && core.hash_watcher) {
              Onicon.log('[core > hash] disable native hash watcher');
              Dom.detachEvent('hashchange', core.hashChanged);
            } else if (window.onhashchange === undefined && core.hash_watcher) {
              Onicon.log('[core > hash] disable fake hash watcher');
              window.clearInterval(core.hash_watcher);
            }

            core.hash_watcher = null;
          });

        }, reconnect_after);
      },


      connectionError: function () {
        core.stopPinger();
        Onicon.log('[core] Error while connecting');
      },

      checkFeature: function (feature, site_utc, no_contacts) {
        site_utc = site_utc ? parseInt(site_utc) : 3;

        if (no_contacts == undefined && (feature.contacts == undefined || feature.contacts.length <= 0)) {
          return false;
        }

        if (feature.enabled) {
          var now = new Date(),
            now_day = now.getDay();

          var correctTime = function (time, utc) {
            return new Date((new Date()).setHours(time.split(':')[0], time.split(':')[1], 0, 0) + (-utc * 60 - new Date().getTimezoneOffset()) * 6e4);
          };
          var checkHours = function (from, to) {
            if (now > to || now < from) return false;
            //if(from.getHours() > to.getHours()) {
            if (now > from || now.getHours() < to.getHours()) {
              return true;
            } else return false;
            // }
          };

          now_day = now_day ? now_day : 7;
          now_day = now_day - 1;
          var week = feature.schedule;

          for (var i in week) {
            var today = week[i];
            if (i == now_day) {
              if (today.from == null || today.to == null) return false;
              else {
                if (today.enabled) {
                  var c_from = correctTime(today.from, site_utc),
                    c_to = correctTime(today.to, site_utc);
                  if (checkHours(c_from, c_to)) return true;
                }
              }
            }
          }
          return false;
        } else {
          return false;
        }
      },

      authorizeResponse: function (data) {
        core.failed_connections_with_ok_state = 0;

        DateSync.init(data.server_time.seconds, data.server_time.timezone);

        core.channels = {
          chat: null,
          site: null
        };

        //если это Викс подгоним размеры фрейма
        if (Onicon.LOADER_PARAMS.wix && Wix != undefined) {
          Wix.resizeWindow(300, 300);
        }


        core.online_disabled = data.mode < 0;
        core.show_server_down = false;
        core.site_info = data.site_info;
        core.live_forms_config = data.live_forms_config;
        core.isolated_sign = data.isolated_sign || null;
        core.isolated_mode = data.isolated_mode || null;
        core.session_start = data.session_start;
        core.region = data.region;
        core.page_start = data.page_start || Math.round((new Date()).getTime() / 1000);
        core.session_page_changes = data.session_page_changes || 0;
        core.total_page_changes = data.total_page_changes || 0;
        core.no_copyright = !!data.no_copyright;

        //можно ли включить быстрый звонок
        core.canCallto = Onicon.navigator.isMobile && core.site_info.callto && core.checkFeature(core.site_info.callto, core.site_info.timezone);
        //можно ли включить "Позвоните мне"
        core.canCallme = !core.canCallto && core.site_info.callme && core.checkFeature(core.site_info.callme, core.site_info.timezone, true);
        //можно ли совершить автодозвон
        core.canCallback = !core.canCallto && core.site_info.callback && core.checkFeature(core.site_info.callback, core.site_info.timezone);
        //Показывать ли кнопку звонка на сайте
        if (core.canCallto || core.canCallme || core.canCallback) core.viewCallbackButton = true;

        if (!core.site_info.colors) {
          core.site_info.colors = ['#07984C', '#A8DB97'];
        }

        core.site_info.mobile_enabled = core.site_info.mobile_enabled == "1";

        if (!core.site_info.panel_title_offline) {
          core.site_info.panel_title_offline = 'Оставьте нам сообщение';
        }

        if (!core.site_info.offline_message) {
          core.site_info.offline_message = core.locale.offline_form_hello;
        }

        var si = core.site_info, i;

        if (!si.offline_name_title) {
          si.offline_name_title = core.locale.offline_form_field_name;
        }
        if (!si.offline_contact_title) {
          si.offline_contact_title = core.locale.offline_form_field_phone_or_email;
        }
        if (!si.offline_body_title) {
          si.offline_body_title = core.locale.offline_form_field_message;
        }

        var is_horizontal = si.bookmark_orientation === 'horizontal';
        si.bookmark_margin_x = is_horizontal ? si.bookmark_margin : 0;
        si.bookmark_margin_y = !is_horizontal ? si.bookmark_margin : 0;

        if (si.panel_position_side === undefined) {
          si.panel_position_side = 'right-bottom';
        }

        si.panel_position = si.panel_position_side.split('-');

        if (si.bookmark_margin === undefined) {
          si.bookmark_margin = 20;
        }

        si.panel_margin = [si.bookmark_margin, 0];
        si.bookmark_margin = [si.bookmark_margin, 0];

        core.auth_channels = data.channels.length;
        for (i = 0; i < data.channels.length; ++i) {
          core.addChannel(data.channels[i]);
        }

        core.ping();

        if (window.onhashchange !== undefined && !core.hash_watcher) {
          Onicon.log('[core > hash] enable native hash watcher');
          Dom.attachEvent('hashchange', core.hashChanged);
          core.hash_watcher = true;
        } else if (window.onhashchange === undefined && !core.hash_watcher) {
          Onicon.log('[core > hash] enable fake hash watcher');

          core.hash_watcher = window.setInterval(function () {
            if (core.hash_watcher_last_url === null) {
              core.hash_watcher_last_url = core.docInfo.location;
            } else if (core.hash_watcher_last_url != core.docInfo.location) {
              core.hash_watcher_last_url = core.docInfo.location;
              core.hashChanged();
            }
          }, 2000);
        }


        if (si.live_forms_mode) {
          core.liveFormsApply();
        }

        Trigger.execute(Trigger.EV_AUTHORIZED);

        if (!core.authorized_once) {
          core.authorized_once = true;
          Trigger.execute(Trigger.EV_AUTHORIZED_ONCE);
          Trigger.execute('onicon-running');
        }
      },


      packet: function (data) {
        data = JSON.parse(data) || {};

        if (!data.flag) {
          Onicon.print('[core] Invalid packet recieved: ', data);
          return;
        }

        var protocol = Onicon.protocol;

        if (data.code) {
          if (data.code & protocol.SUBCODE_BIT_CRITICAL) {
            core.stop = data;
          } else if (data.code & protocol.SUBCODE_BIT_CLEAR_COOKIE) {
            Onicon.log('[core:packet] Clear cookie and history for user_id ' + core.user_id);
            core.removeMessagesData();
            Cookie.remove(Onicon.COOKIE_PREFIX + 'user_id');
            Cookie.remove(Onicon.COOKIE_PREFIX + 'user_hash');
            core.rerun = 'Cookie was cleared by server subcode';
          }
        }

        switch (data.flag) {
          // Авторизация прошла успешно
          case protocol.SERVER_CODE_AUTHORIZATION_DONE:
            core.was_ws_response = true;
            core.auth_num++;

            // @TODO: Remove this IF() {} block on Jan 2050
            if (!core.isolated && data.site_domain && !Cookie.get(Onicon.COOKIE_PREFIX + 'site_domain')) {
              core.site_domain = data.site_domain;
              Cookie.setDomain('.' + data.site_domain);
              Cookie.set(Onicon.COOKIE_PREFIX + 'site_domain', data.site_domain, Onicon.auth_cookie_ttl);

              var cookies = {};
              cookies['user_id'] = Onicon.auth_cookie_ttl;
              cookies['user_hash'] = Onicon.auth_cookie_ttl;
              cookies['chat_opened'] = Onicon.other_cookie_ttl;
              cookies['polling_mode'] = Onicon.polling_mode_cookie_ttl;
              cookies['site_domain'] = Onicon.other_cookie_ttl;
              cookies['panel_position'] = Onicon.other_cookie_ttl;
              cookies['isolated_size'] = Onicon.other_cookie_ttl;
              cookies['button_state_control-enter'] = Onicon.other_cookie_ttl;
              cookies['button_state_control-sound'] = Onicon.other_cookie_ttl;

              for (var cookie_name in cookies) {
                if (!cookies.hasOwnProperty(cookie_name)) continue;
                Cookie.setDomain(null);
                var cookie_value = Cookie.get(Onicon.COOKIE_PREFIX + cookie_name);
                if (cookie_value) {
                  Cookie.remove(Onicon.COOKIE_PREFIX + cookie_name);
                  Cookie.setDomain('.' + data.site_domain);
                  Cookie.set(Onicon.COOKIE_PREFIX + cookie_name, cookie_value, cookies[cookie_name]);
                }
              }
            }

            if (!core.isolated && data.site_domain) {
              core.site_domain = data.site_domain;
              Cookie.setDomain('.' + data.site_domain);
              if (!Cookie.get(Onicon.COOKIE_PREFIX + 'site_domain')) {
                Cookie.set(Onicon.COOKIE_PREFIX + 'site_domain', data.site_domain, Onicon.auth_cookie_ttl);
              }
            }

            if (!window.megacounter_key) {
              window.megacounter_key = data.megacounter_key;
              Onicon.loader.script({
                url: document.location.protocol + '//counter.megagroup.ru/loader.js',
                async: true
              });
            }

            if (data.channels && data.site_info) {
              core.authorizeResponse(data);
            }

            if (data.yandex_metrika_key) {
              core.yandex_metrika.yandex_metrika_key = data.yandex_metrika_key;
            } else if (data.site_info.ymstat && core.site_info.ymstat.active) {
              core.yandex_metrika.yandex_metrika_key = data.site_info.ymstat.counter_id;
            }

            core.YMInsert();
            break;

          // Ошибка авторизации
          case protocol.SERVER_CODE_AUTHORIZATION_FAIL:
            core.was_ws_response = true;
            core.auth_num++;
            break;

          // Посетитель забанен
          case protocol.SERVER_CODE_VISITOR_BANNED:
            core.systemMessage(core.locale.msg_banned, 'banned');
            break;

          // Успешная регистрация нового посетителя
          case protocol.SERVER_CODE_REGISTRATION_DONE:
            // This code will never run in isolated mode
            if (data.site_domain) {
              core.site_domain = data.site_domain;
              Cookie.setDomain('.' + data.site_domain.split(':')[0]);
              Cookie.set(Onicon.COOKIE_PREFIX + 'site_domain', data.site_domain,
                Onicon.auth_cookie_ttl);
            }

            core.was_ws_response = true;
            core.user_id = data.user_id;
            core.user_hash = data.user_hash;
            Cookie.set(Onicon.COOKIE_PREFIX + 'user_id', core.user_id, Onicon.auth_cookie_ttl);
            Cookie.set(Onicon.COOKIE_PREFIX + 'user_hash', core.user_hash, Onicon.auth_cookie_ttl);

            //Onicon.rpc.call({
            //    ctrl: "main",
            //    action: "storeFingerprint",
            //    params: {
            //        fingerprint: Onicon.core.fingerprint,
            //        type: 0,
            //        data: {
            //            domain: location.href,
            //            user_id: Onicon.core.user_id,
            //            site_id: Onicon.LOADER_PARAMS.site_id
            //        }
            //    }
            //});

            core.authorize();
            break;

          case protocol.SERVER_CODE_REGISTRATION_FAIL:
            core.was_ws_response = true;
            break;

          // New user in channel
          case protocol.SERVER_CODE_USER_COME_TO_CHANNEL:
            core.userComeToChannel(data.channel_id, data.user_id, data.user_type, data.extra_info || null);
            break;

          // User quit channel
          case protocol.SERVER_CODE_USER_LEAVE_CHANNEL:
            core.userLeaveChannel(data.channel_id, data.user_id, data.user_type, data.channel_id);
            break;

          case protocol.SERVER_CODE_CHANNEL_LIST:
            core.usersInChannel(data.channel_id, data.users, data.operators);
            break;

          // Channel add
          case protocol.SERVER_CODE_CHANNEL_CONNECTED:
            core.addChannel(data.channels[0]);
            break;

          // Channel removed
          case protocol.SERVER_CODE_CHANNEL_DISCONNECTED:
            core.removeChannel(data.channel_id);
            break;

          // User information has been updated
          case protocol.SERVER_CODE_USER_WAS_UPDATED:
            core.updateUser(data.channel_id, data.user_id, data.user_type, data.extra_info);
            break;

          case protocol.SERVER_CODE_MESSAGE_SEND_DONE:
          case protocol.SERVER_CODE_MESSAGE_SEND_FAIL:
            core.messageProcessed();
            break;

          case protocol.SERVER_CODE_CHAT_MESSAGE:
            core.chatMessageCame(data.message);
            break;

          case protocol.SERVER_CODE_USER_TYPING:
            core.userTyping(data.user_id, data.user_type, data.channel_id);
            break;

          case protocol.SERVER_CODE_SEND_LIVE_FORM_DONE:
            core.liveFormsDelete(true);
            break;

          case protocol.SERVER_CODE_SEND_LIVE_FORM_FAIL:
            core.liveFormsDelete(false);
            break;

          // это сделано, чтобы клиент не переключался на проксю в момент пиковых нагрузок
          // т.е. мы какбе говорим, что авторизация таки была
          case protocol.SERVER_CODE_AUTH_OVERLOADED:
            core.was_ws_response = true;
            break;

          case protocol.SERVER_CODE_ISOLATED_MODE_ENABLED:
            Onicon.log('[core] Isolated mode enabled');
            core.isolated_mode = true;
            if (core.isolated) {
              window.close();
            } else {
              core.hideBlock(core.panel_id);
              core.showBlock(core.bookmark_id);
            }
            break;

          case protocol.SERVER_CODE_ISOLATED_MODE_DISABLED:
            Onicon.log('[core] Isolated mode disabled');
            core.isolated_mode = false;
            if (!core.isolated) {
              core.showBookmark();
            }
            break;

        case protocol.SERVER_CODE_NEW_SERVER:
            Cookie.set(Onicon.COOKIE_PREFIX + 'srv', Number(data.real_server_id), Onicon.auth_cookie_ttl);
            break;
          case 2002: // Contacts response
            Trigger.execute('contacts_response', data);
            break;
        }

        Trigger.execute(Trigger.EV_PACKET, data);
        if (data.token) {
          Trigger.execute(Trigger.EV_PACKET_TOKEN(data.token), data);
        }
      },


      /**
       * Update user info
       * @param {String} channel_id
       * @param {String} user_id
       * @param {Number} user_type
       * @param {Object} user_info
       */
      updateUser: function (channel_id, user_id, user_type, user_info) {
        //user_id может быть звездочкой!!! не передавать в другие методы!!!
        var ch = core.channels[channel_id], handler, i, k, f, l, users, chunks;

        handler = function (user) {
          for (k in user_info) {
            if (user_info.hasOwnProperty(k)) {
              if (k[0] === '$') {
                for (f in user_info[k]) {
                  if (user_info[k].hasOwnProperty(f)) {
                    switch (k) {
                      case '$push': {
                        user[f].push(user_info[k][f]);
                        break;
                      }

                      case '$pull': {
                        for (l = 0; l < user[f].length; ++l) {
                          if (user[f][l] === user_info[k][f]) {
                            user[f].splice(l--, 1);
                          }
                        }
                        break;
                      }

                      case '$inc': {
                        user[user_info[k][f]]++;
                        break;
                      }

                      case '$set': {
                        chunks = f.split('.');
                        if (chunks.length === 2) {
                          i = parseInt(chunks[1], 10);
                          if (user[chunks[0]] === undefined) {
                            user[chunks[0]] = isFinite(i) ? [] : {};
                          }
                          user[chunks[0]][chunks[1]] = user_info[k][f];
                        }
                        break;
                      }
                    }
                  }
                }
              } else {
                user[k] = user_info[k];
              }
            }
          }
        };

        if (ch) {
          users = user_type === protocol.TYPE_VISITOR ? ch.users : ch.operators;

          if (user_id === '*') {
            for (i in users) {
              if (users.hasOwnProperty(i)) {
                handler(users[i]);
              }
            }
          } else if (users[user_id]) {
            handler(users[user_id]);
          }
        }

        Trigger.execute(Trigger.EV_V_USER_UPDATED);
      },


      ping: function () {
        core.stopPinger();
        Transport.send({flag: 0});
        core.pinger = setTimeout(core.ping, Onicon.PING_TIMEOUT);
      },


      stopPinger: function () {
        if (core.pinger) {
          window.clearTimeout(core.pinger);
          core.pinger = null;
        }
      },


      hashChanged: function () {
        Onicon.log('[core] hashChanged', core.docInfo.location, core.docInfo.title);
        Transport.send({
          flag: Onicon.protocol.CLIENT_CODE_VISITOR_UPDATE_LAST_PAGE,
          location: core.docInfo.location,
          title: core.docInfo.title
        });
        Trigger.execute(Trigger.EV_V_HASH_CHANGED);
      },


      /**
       * первый init
       */
      initChat: function () {
        Onicon.log('[core:initChat]');

        if (Onicon.navigator.isMobile) {
          Cookie.set(Onicon.COOKIE_PREFIX + 'chat_opened', false, -1);
        }

        core.site_button = document.getElementById('onicon_site_button') || false;

        core.visibility_mode = core.site_info.panel_visibility_mode
          ? core.site_info.panel_visibility_mode
          : (core.site_info.panel_invisible ? 3 : 1);

        core.last_state = core.current_state;

        // если есть операторы с которыми идет общение
        core.current_state = core.channels.chat.operators.length || core.channels.site.operators.length
          ? core.STATE_ONLINE
          : core.STATE_OFFLINE;

        if (core.last_state === core.STATE_NULL) {

          //if(!Onicon.navigator.isMobile) {
          core.drawPanel(true);
          //}

          core.drawBookmark(core.current_state == core.STATE_ONLINE ? core.site_info.panel_title : core.site_info.panel_title_offline, core.current_state > 0);
          core.drawButton();
          core.updateOperator();

          if (!core.isolated && core.isolated_mode) {
            core.showBlock('bookmark');
          } else {
            if (core.isolated || Cookie.get(Onicon.COOKIE_PREFIX + 'chat_opened')) {
              core.panel_show_allow = true;
              core.showPanel();
            } else {
              core.showBookmark();
            }
          }
        }

        if (core.current_state < core.STATE_NULL) {
          core.switchPanelState(core.STATE_OFFLINE);
        } else {
          core.switchPanelState(core.STATE_ONLINE);
          if (core.last_state === core.STATE_NULL && core.getById('message-area').innerHTML === '') {
            core.systemMessage(core.locale.msg_operators_state_changed_to_online, 'operators-state');
          }
        }
        core.updateOperator();

        core.resize_callback();
        Onicon.log('INIT OK');
        Onicon.ready = true;
      },

      processOfflineMessage: function (data) {

        window.ONICON_OFFLINE_SEND && window.ONICON_OFFLINE_SEND.call();

        Trigger.execute('offlineForm-send');

        var button = core.getById('send-offline-button');
        if (button) {
          button.disabled = false;
          var offline_send_msg = core.getById('system-message');

          Dom.removeClass(offline_send_msg, 'onicon-msg-error');
          Dom.addClass(offline_send_msg, 'onicon-msg-success');

          offline_send_msg.innerHTML = core.locale.offline_form_send_success;
          setTimeout(function () {
            core.hideBlock('system-message');
            $(".onicon-modal-loading").fadeOut();
            if (!core.isolated) core.switchPanels()
          }, 500)
        }
      },

      processCallbackMessage: function (data) {

        Trigger.execute('callback-send');

        core.getById('system-message-call').innerHTML = "Запрос отправлен!";
        core.getById('system-message-call').style.display = "block";

        window.ONICON_CALLBACK_SEND && window.ONICON_CALLBACK_SEND.call();

        setTimeout(function () {
          $(".onicon-modal-loading").fadeOut();
          core.getById('system-message-call').style.display = "none";
          Dom.addClass(core.getById('modal-window'), 'modal-hidden');


          core._getById('onicon-fog').fadeOut('slow', function () {
            Onicon.core._getById('onicon-fog').remove();
          })

          core.showBookmark();
          if (!Navigator.isMobile) {
            Trigger.execute('sas_enable');
          }

        }, 1500);


        //var button = core.getById('send-offline-button');
        //if (button) {
        //    var dom = Onicon.lib('dom'), i, block;
        //    button.disabled = false;
        //    var offline_send_msg = core.getById('system-message');
        //
        //    Dom.removeClass(offline_send_msg, 'onicon-msg-error');
        //    Dom.addClass(offline_send_msg, 'onicon-msg-success');
        //
        //    offline_send_msg.innerHTML = core.locale.offline_form_send_success;
        //    setTimeout(function(){
        //        core.hideBlock('system-message');
        //        if(!core.isolated) core.switchPanels()
        //    }, 500)
        //}
      },

      processVoxCallback: function (data) {

        Trigger.execute('callback-voice');

        core.getById('system-message-call').innerHTML = "Ожидайте звонка!";
        core.getById('system-message-call').style.display = "block";
        window.ONICON_CALLBACK_SEND && window.ONICON_CALLBACK_SEND.call();
        setTimeout(function () {
          $(".onicon-modal-loading").fadeOut();
          core.getById('system-message-call').style.display = "none";
          Dom.addClass(core.getById('modal-window'), 'modal-hidden');
          core.showBookmark();
          if (!Navigator.isMobile) {
            Trigger.execute('sas_enable');
          }

          core._getById('onicon-fog').fadeOut('slow', function () {
            Onicon.core._getById('onicon-fog').remove();
          })

        }, 1500);
      },

      offlineReader: function (from) {
        if (!from) {
          var elements = core.getById('offline-form').getElementsByClassName('onicon_chat-form-row');
          if (core.current_state == core.STATE_ONLINE) {
            elements = core.getById('widget-area').getElementsByClassName('onicon_chat-form-row');
          }
        } else {
          var elements = core.getById(from).getElementsByClassName('onicon_chat-form-row')
        }

        var user_results = [];
        for (var i = 0; i < elements.length; i++) {
          var element = elements[i];
          if (element.length) element = element[0];
          var type = element.getAttribute('type');
          switch (type) {
            case 'input':
              user_results.push({
                type: 'input',
                title: element.getElementsByTagName('label')[0].innerHTML,
                validation: element.getElementsByTagName('input')[0].getAttribute('validate'),
                result: element.getElementsByTagName('input')[0].value
              });
              element.getElementsByTagName('input')[0].value = '';
              break;
            case 'textarea':
              user_results.push({
                type: 'textarea',
                title: element.getElementsByTagName('label')[0].innerHTML,
                validation: element.getElementsByTagName('textarea')[0].getAttribute('validate'),
                result: element.getElementsByTagName('textarea')[0].value
              });
              element.getElementsByTagName('textarea')[0].value = '';
              break;
          }
        }
        return user_results;
      },

      drawPanel: function (save_size) {
        save_size = save_size ? save_size : false;

        var panel = core.getById(core.panel_id),
          callback_button = core.getById('float_button_wrap'),
          send_button, resizer, panel_content;

        if (!callback_button) {
          callback_button = document.createElement('div');
          Dom.addClass(callback_button, 'onicon-callme__wrap onicon-callme__wrap--minimal ');
          callback_button.id = core.createId('float_button_wrap');
          callback_button.style.display = 'none';
          if (core.viewCallbackButton) {
            document.body.appendChild(callback_button);
          }
        }

        if (!panel) {
          panel = document.createElement('div');
          panel.id = core.createId(core.panel_id);
          document.body.appendChild(panel);
        }

        panel.className = 'onicon_chat_is-hidden onicon_chat-animation onicon_chat onicon_chat-window onicon_chat-' + (core.current_state === core.STATE_ONLINE ? 'online' : 'offline') + ' ' + (core.isolated ? 'onicon_chat-isolated' : '');

        var c1 = core.site_info.colors[0],
          c2 = core.site_info.colors[1];
        var tel_link = '',
          contacts = '';

        if (core.canCallto) {
          tel_link = '<a href = "tel:' + core.site_info.callto.contact_phone + '" onClick="return window.confirm(\'Позвонить сейчас?\')">';
        }

        if (core.site_info.contact_line_1 && core.site_info.contact_line_2) {
          contacts = '<div class="onicon_chat-contacts"> \
                                        <span>' + core.site_info.contact_line_1 + '</span><br> \
                                        <span>' + core.site_info.contact_line_2 + '</span> \
                                    </div>';
        } else if (core.site_info.contact_line_1 || core.site_info.contact_line_2) {
          contacts = '<div class="onicon_chat-contacts"> \
                                        <span>' + (core.site_info.contact_line_1 ? core.site_info.contact_line_1 : core.site_info.contact_line_2) + '</span> \
                                    </div>';
        }

        switch (core.site_info.callback_type) {
          case 999:
            callback_button.innerHTML = '';
            break;
          case 2:
            callback_button.innerHTML = tel_link + '<div id="' + core.createId('circle-inner') + '" class="onicon-button-animation" style="background-color: ' + core.site_info.callback_color + '"> \
                            <div class="onicon-roll-animation" style="background-position: 4000px 0px;"></div> \
                            </div>' + (tel_link ? '</a>' : '');
            Dom.addClass(callback_button, 'onicon-button-width');
            break;
          case 1:
            callback_button.innerHTML = tel_link + '<div class="onicon-callme__msg" style="background-color: ' + core.site_info.callback_color + '"><span>Заказать обратный звонок</span></div> \
                            <div class="onicon-callme__btn"> \
                            <svg class="onicon-callme__bg" width="60px" height="59px" viewBox="0 0 62 59" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"> \
                                <title></title> \
                                <desc></desc> \
                                <defs></defs> \
                                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"> \
                                    <g id="first" sketch:type="MSArtboardGroup" transform="translate(-160.00000, -40.500000)" fill="#FFFFFF"> \
                                        <path style="fill: ' + core.site_info.callback_color + '" d="M215.101958,85.7288134 L214.767042,84.8409417 L215.242926,84.0199553 C217.691919,79.7950037 219,74.995299 219,70 C219,54.536027 206.463973,42 191,42 C175.536027,42 163,54.536027 163,70 C163,85.463973 175.536027,98 191,98 C196.050346,98 200.900453,96.6628532 205.157914,94.1624317 L205.91361,93.7186085 L206.752152,93.9733712 L219.968628,98.152832 L215.101958,85.7288134 L215.101958,85.7288134 Z" id="Shape-Copy" sketch:type="MSShapeGroup"></path> \
                                    </g> \
                                </g> \
                             </svg> \
                            <svg class="onicon-callme__phone" width="34px" height="33px" viewBox="0 0 34 33" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> \
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> \
                                    <g transform="translate(-34.000000, -34.000000)" fill="#FFFFFF"> \
                                        <g transform="translate(20.000000, 20.000000)"> \
                                            <g transform="translate(14.000000, 13.000000)"> \
                                                <path d="M26.35,33.9353027 C26.35,33.9353027 28.475,34.0603027 30.0535714,32.8103027 C31.6321429,31.5603027 33.0892857,29.5603027 33.0892857,29.5603027 C33.0892857,29.5603027 34.5464286,25.7478027 30.9642857,23.9353027 C29.3465094,23.116737 27.8278008,22.7188446 26.6486438,22.5286116 C25.2168658,22.2976233 23.6801344,22.9182845 23.3773444,23.1910253 C22.4080594,24.0641178 20.4694894,25.8103027 20.4694894,25.8103027 C20.4694894,25.8103027 15.915918,24.6853028 12.7587751,21.9978027 C9.60163225,19.3103027 8.50877511,13.9353027 8.50877511,13.9353027 L10.815918,10.6228027 C10.815918,10.6228027 11.9694894,8.81030273 10.4516323,5.37280273 C8.93377511,1.93530273 7.59355469,0.997802734 5.89355469,0.997802734 C4.19355469,0.997802734 1.03641183,4.93530273 1.03641183,4.93530273 C1.03641183,4.93530273 -0.726674107,8.25048828 1.94475446,15.9379883 C4.61618304,23.6254883 10.8135454,30.0656738 16.8804687,32.0004883 C22.9473921,33.9353027 26.35,33.9353027 26.35,33.9353027 Z"></path> \
                                            </g> \
                                        </g> \
                                    </g> \
                                </g> \
                            </svg> \
                        </div>' + (tel_link ? '</a>' : '');
            break;
          case 0:
          default:
            callback_button.innerHTML = tel_link + '<div id="' + core.createId('circle-inner') + '" class="onicon-button-animation" style="background-color: ' + core.site_info.callback_color + '"> \
                            <div class="onicon-roll-animation" id="' + core.createId('roll-animation') + '"></div> \
                            </div>' + (tel_link ? '</a>' : '');
            Dom.addClass(callback_button, 'onicon-button-width');
        }

        panel.innerHTML += '<div class="onicon_chat-header" style="background-color: ' + c1 + '; border-color: ' + c1 + ';"> \
                            <div class="onicon_chat-window-drag" title="' + core.locale.move_title + '" id="' + core.createId('drag') + '"> \
                                <strong id="' + core.createId('offline-title') + '">' + core.site_info.panel_title_offline + '</strong> \
                            </div> \
                            <div class="onicon_chat-avatar"> \
                                <div class="onicon_chat-icon"></div> \
                                <div class="onicon_chat-photo" id="' + core.createId('operator-avatar') + '"> \
                                    <div class="onicon_chat-photo-fr" id="' + core.createId('avatar-frame') + '"> \
                                        <img id="' + core.createId('operator-photo') + '" height="54" width="54" alt=""/> \
                                    </div> \
                                </div> \
                            </div> \
                            <div class="onicon_chat-operator-card"> \
                                <div class="onicon_chat-card-inner"> \
                                    <div class="onicon_chat-operator-name" id="' + core.createId('operator-name') + '"><strong>' + core.locale.main_title + '</strong> \
                                    </div> \
                                    ' + contacts + ' \
                                </div> \
                            </div> \
                        </div> \
                        <div class="onicon_chat-tabs-nav" id="' + core.createId('offline-mode-nav') + '" style="background-color: ' + c1 + ';"> \
                            <ul class="onicon_chat-tabs-list"> \
                                <li class="onicon_chat-tab-name" id="' + core.createId('offline-switch-form') + '"><span>' + core.locale.panel_switch_label_offline_form + '</span></li> \
                                <li class="onicon_chat-tab-name" id="' + core.createId('offline-switch-history') + '"><span>' + core.locale.panel_switch_label_dialog_history + '</span></li> \
                            </ul> \
                        </div> \
                        <div class="onicon_chat-content" id="' + core.createId('dim-dependent-area') + '"> \
                            <div class="onicon_chat-tab-container" id="' + core.createId('message-area-wrap') + '"> \
                                <span class="onicon_chat-typing" id="' + core.createId('status') + '">' + core.locale.typing + '</span> \
                                <div class="onicon_chat-body" id="' + core.createId('scroll-message-area') + '"> \
                                    <div class="onicon_chat-dialogue" id="' + core.createId('message-area') + '"></div> \
                                </div> \
                            </div> \
                            <div class="onicon_chat-tab-container" id="' + core.createId('offline-form-area') + '"> \
                            <div class="system-message" id="' + core.createId('system-message') + '" style="display: none;"></div> \
                                <div class="onicon_chat-body onicon_chat-offline-form" id="' + core.createId('offline-form') + '"> \
                                <div class="onicon_chat-vertical-scroll" id="' + core.createId('scroll-message-tool') + '"> \
                                        <div class="onicon_chat-scroll-runner" style="background-color: ' + c1 + ';" id="' + core.createId('scroll-message-runner') + '"></div> \
                                    </div> \
                                </div> \
                            </div> \
                        </div> \
                        <div class="onicon_chat-footer"> \
                            <ul class="onicon_chat-tools-panel"> \
                                <li class="onicon_chat-tool onicon_chat-key-enter disabled" id="' + core.createId('control-enter') + '"> \
                                    <a href="javascript:;">&nbsp;</a> \
                                </li> \
                                <li class="onicon_chat-tool onicon_chat-key-sound" id="' + core.createId('control-sound') + '"> \
                                    <a href="javascript:;">&nbsp;</a> \
                                </li> \
                                <li class="onicon_chat-tool onicon_chat-key-voice disabled">' + (Navigator.isChrome && !Navigator.isYandex ? '<input id="' + core.createId('text-to-speach') + '" x-webkit-speech="x-webkit-speech" class="onicon-input-speach" title="' + core.locale.voice_input + '">' : '' ) + '</li> \
                                <li class="onicon_chat-quit-btn" title="' + core.locale.minimize_title + '" id="' + core.createId('control-close') + '"> \
                                    <a href="javascript:;">' + core.locale.close + '</a> \
                                </li> \
                            </ul> \
                            <div class="onicon_chat-msg-area"> \
                                <button class="onicon_chat-send-btn" style="background-color: ' + c1 + '; border-color: ' + c1 + ';" id="' + core.createId('send-button') + '" title="' + core.locale.title_enter_send + '">' + core.locale.online_form_send_button + '</button> \
                                <div class="onicon_chat-container-msg"> \
                                    <textarea cols="30" rows="10" id="' + core.createId('input-area') + '" style="background: transparent;" placeholder="' + core.locale.online_input_message_hint + '"></textarea> \
                                </div> \
                            </div> \
                        </div> \
                        <div class="onicon_chat-title">' + (core.no_copyright ? '&nbsp;' : core.locale.footer) + '</div> \
                        <div class="onicon_chat-window-resizer" id="' + core.createId('resizer') + '"></div> \
                        <ul class="onicon_chat-window-controls"> \
                            <li class="onicon_chat-expand" title="' + core.locale.maximize_title + '" id="' + core.createId('panel-maximize-button') + '">&nbsp;</li> \
                            <li class="onicon_chat-close" title="' + core.locale.minimize_title + '" id="' + core.createId('panel-hide-button') + '">&nbsp;</li> \
                        </ul> \
                        <div style="display: none;"> \
                            <audio id="' + core.createId('audio-notify') + '" preload="auto" autobuffer> \
                            <source src="https://cp.onicon.ru/audio/notify-new-message.ogg" type="audio/ogg"> \
                            <source src="https://cp.onicon.ru/audio/notify-new-message.mp3" type="audio/mpeg"> \
                            <source src="https://cp.onicon.ru/audio/notify-new-message.aac" type="audio/aac"> \
                            <source src="https://cp.onicon.ru/audio/notify-new-message.wav" type="audio/wav"> \
                        </audio> \
                    </div>';
        //<div class="onicon-system-dialog" id="' + core.createId('system-dialog') + '" style="display: none;">\
        //    <div class="system-dialog-header">\
        //        <ul class="onicon_chat-window-controls"  class="onicon-sysdlg-control">\
        //            <li class="onicon_chat-close" title="Закрыть" id="' + core.createId('system-dialog-close') + '">&nbsp;</li>\
        //        </ul>\
        //    </div>\
        //    <div class="onicon-system-message">Данный диалог был вам полезен?</div>\
        //    <div class="onicon-system-dlg-buttons">\
        //        <button id="' + core.createId('system-dialog-oper-yes') + '" class="system-dialog-yes">Да</button>\
        //        <button id="' + core.createId('system-dialog-oper-no') + '" class="system-dialog-no">Нет</button>\
        //    </div>\
        //</div>';

        // core.offlineFormMessage({message : core.site_info.offline_message});

        core.applyPanelDim();
        core.clearTyping();

        // panel.style.visibility = 'hidden';

        send_button = core.getById('send-button');

        var default_send_btn_state = true;
        var default_audio_btn_state = true;
        if (core.isolated) {
          var window_url = Onicon.lib('url').parse(document.location.href);
          if (window_url.params) {
            if (window_url.params.send_btn) {
              default_send_btn_state = !!parseInt(window_url.params.send_btn);
            }

            if (window_url.params.audio_btn) {
              default_audio_btn_state = !!parseInt(window_url.params.audio_btn);
            }
          }
        }
        Onicon.log('[core] Default btn states: send=%s audio=%s', default_send_btn_state, default_audio_btn_state);

        core.initiateButtonState({
          id: 'control-enter',
          default_state: default_send_btn_state,
          titles: {
            enabled: core.locale.switch_ctrl_enter_send,
            disabled: core.locale.switch_enter_send
          },
          use_cookie: !core.isolated,
          enabled_cb: function () {
            send_button.title = core.locale.title_enter_send;
            this.style.backgroundColor = core.site_info.colors[0];
          },
          disabled_cb: function () {
            send_button.title = core.locale.title_ctrl_enter_send;
            this.style.backgroundColor = '#999';
          }
        });

        send_button.title = core.checkButtonState('control-enter') ? core.locale.title_enter_send : core.locale.title_ctrl_enter_send;

        core.initiateButtonState({
          id: 'control-sound',
          default_state: default_audio_btn_state,
          titles: {
            enabled: core.locale.audio_notification_press_to_disable,
            disabled: core.locale.audio_notification_press_to_enable
          },
          use_cookie: !core.isolated,
          enabled_cb: function () {
            core.SOUNDS_ON = true;
            this.style.backgroundColor = core.site_info.colors[0];
          },
          disabled_cb: function () {
            core.SOUNDS_ON = false;
            this.style.backgroundColor = '#999';
          }
        });

        var input_area = core.getById('input-area');
        input_area.onfocus = function () {
          core.TEXTAREA_FOCUSED = true;
          if (core.isolated) {
            blinker.disable();
          }
        };

        input_area.onblur = function () {
          core.TEXTAREA_FOCUSED = false;
        };

        core.scrollBar.init(core.getById('scroll-message-area'));

        Dom.attachEvent('mouseup', function (e) {
          try {
            e = e || window.event;
            var core = Onicon.core, i;
            var target = e.target || e.srcElement;
            var ids = ['input-area', 'offline-field-name', 'offline-field-contact', 'widget-offline-field-message',
              'offline-field-captcha'];
            for (i = 0; i < ids.length; ++i) {
              var elem = core.getById(ids[i]);
              elem[elem === target ? 'focus' : 'blur']();
            }
          } catch (e) {
          }
        }, document);

        var offline_nav_history = this.getById('offline-switch-history');
        var offline_nav_form = this.getById('offline-switch-form');

        if (offline_nav_history && offline_nav_form) {
          offline_nav_history.onclick = function () {
            core.offline_active_state = 'history';
            core.switchOfflinePanelState(true);
          };

          offline_nav_form.onclick = function () {
            core.switchOfflinePanelState(false);
            core.offline_active_state = 'widget';
          };
        }

        // var text_to_speach = core.getById('text-to-speach');
        // if (text_to_speach) {
        //   text_to_speach.onclick = function () {
        //     this.blur();
        //   };
        //   text_to_speach.onwebkitspeechchange = function () {
        //     core.getById('input-area').value += this.value;
        //     this.value = '';
        //   }
        // }

        var send = function () {
          window.ONICON_ONLINE_SEND && window.ONICON_ONLINE_SEND.call();
          core.sendMessage();
        };

        Dom.attachEvent('keyup', function (ev) {
          if (core.TEXTAREA_FOCUSED) {
            Trigger.execute(Trigger.EV_V_VISITOR_TYPING);
            if (!Cookie.get(Onicon.COOKIE_PREFIX + 'user_start_typing')) {
              Cookie.set(Onicon.COOKIE_PREFIX + 'user_start_typing', '1', Onicon.polling_mode_cookie_ttl);
              Trigger.execute(Trigger.EV_V_VISITOR_TYPING_ONCE);
            }

            if (core.CAN_SEND_TYPING_NOTIFICATION) {
              Transport.send({
                flag: Onicon.protocol.CLIENT_CODE_TYPING,
                channel_id: core.channels.chat.channel_id
              });

              core.CAN_SEND_TYPING_NOTIFICATION = false;
              setTimeout(function () {
                core.CAN_SEND_TYPING_NOTIFICATION = true;
              }, Onicon.TYPING_TIME);
            }

            var send_mode_control = core.getById('control-enter'),
              enter_send_mode = !Dom.hasClass(send_mode_control, 'disabled');

            if (enter_send_mode) {
              if ((ev.ctrlKey && ev.keyCode === 13) || ev.keyCode === 10) {
                Dom.insertAtCaret(core.getById('input-area'), "\n");
              } else if (ev.keyCode === 13) {
                send();
              }
            } else if ((ev.ctrlKey && ev.keyCode === 13) || ev.keyCode === 10) {
              send();
            }
          }
        });

        Trigger.bindonce(Trigger.EV_V_SAS_LOADED, function () { // дождемся пока подгрузится инфа о авторассылках
          if (core.channels.chat.messages.length) { // стереть все, только если в истории что-то есть
            core.getById('message-area').innerHTML = '';
          }
          for (var i = 0; i < core.channels.chat.messages.length; i++) {
            var mess = core.channels.chat.messages[i];
            if (!mess.autosend && !core.online_disabled) {
              Dom.addClass(core.getById('offline-mode-nav'), 'onicon_chat-full-mode');
              core.has_manual_messages = true;
            }

            // Обрабока "временных" авторассылок
            var draw = true;
            var sas = null;
            if (mess.autosend) { // если это авторассылка
              sas = Onicon.sas.getSas(mess.autosend); // ищем данные по этой рассылке
              if (sas && sas.rules && sas.rules.temporary) { // рассылка есть и правила есть и она временная авторассылка
                var next_message = core.channels.chat.messages[(i + 1)]; // ищем следующее сообщение

                // сообщения либо вообще нет, либо оно не от посетителя
                if (!next_message || (next_message && next_message.sender_type != Onicon.protocol.TYPE_VISITOR)) {
                  draw = false; // тогда скрываем
                }
              }
            }

            draw && core.drawMessage(mess);

            core.applyPanelDim();

            // Для оффлайн режима всегда будем отображать последнюю авторассылку
            if (core.current_state == core.STATE_OFFLINE && sas && (sas.mode == 0 || sas.mode == 2) && !sas.rules.oper_out && !mess.subsystem) {
              // core.offlineFormMessage(mess);
            }
          }
        });

        core.getById('send-button').onclick = send;

        //core.getById('system-dialog-oper-yes').onclick = function() {core.operatorRaiting(1)};
        //core.getById('system-dialog-oper-no').onclick = function() {core.operatorRaiting(2)};
        //core.getById('system-dialog-close').onclick = function() {
        //    var sys_dialog = core.getById('system-dialog');
        //    sys_dialog.style.display = "none";
        //};

        if (!core.isolated) {
          core.getById('panel-hide-button').onclick = core.switchPanels;
          core.getById('control-close').onclick = core.switchPanels;
          core.getById('panel-maximize-button').onclick = core.openIsolatedWindow;
        } else {
          core.getById('control-close').onclick = core.closeWindow;
        }

        Dom.attachEvent('keyup', function (e) {
          if (e.altKey && (e.keyCode === 48 || e.keyCode === 96)) {
            core.switchPanels();
          }
        });

        document.onmouseout = function (e) {
          e = e ? e : window.event;
          var from = e.relatedTarget || e.toElement;
          if ((!from || from.nodeName == "HTML") && e.clientY <= 0) {
            Trigger.execute(Trigger.EV_V_SITE_CLOSE);
          }
        };

        if (!core.isolated) {
          // Делмаем окошко общения "перетаскиваемым", при каждом изменении координат запоминаем смещение
          Dom.draggable({
            target: panel,
            pointer: core.getById('drag'),
            position_x: core.panel_dim.pos_x,
            position_y: core.panel_dim.pos_y,
            on_move: function (margin_x, margin_y) {
              core.panel_dim.margin_x = margin_x;
              core.panel_dim.margin_y = margin_y;
              core.applyPanelDim();
            },
            on_start: function () {
              core.getById('panel').style.boxShadow = 'rgba(0, 0, 0, 0.18) 6px 7px 10px';
              Dom.removeClass(core.getById('panel'), 'onicon_chat-animation');
            },
            on_end: function () {
              core.getById('panel').style.boxShadow = 'rgba(0, 0, 0, 0.18) 0px 0px 10px';
              Dom.addClass(core.getById('panel'), 'onicon_chat-animation');
            }
          });

          Dom.attachEvent('click', function () {
            if (Onicon.navigator.isMobile) {
              if (!core.canCallto) Onicon.widgets.showCallback();
            } else {
              Onicon.widgets.showCallback();
            }
          }, callback_button);

          // Выполняем инициализацию "растягивания" окошка
          core.panelResizeInit();

          Dom.attachEvent('resize', core.resize_callback);
          Dom.attachEvent('scroll', core.resize_callback);

          core.fitPanelToWindow();
        }

        (function () {
          // Flash audio for old browsers and ie
          var audio = panel.getElementsByTagName('audio');
          if (audio.length && !audio[0].play && Navigator.isFlashAvailable()) {
            var div = document.createElement('div');
            audio[0].parentNode.appendChild(div);
            div.innerHTML += '' +
              '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" id="OniconAudio" name="OniconAudio">' +
              '<param name="movie" value="' + Onicon.URL_STATIC + 'js/oniconaudio.swf?_v=' + Onicon.VERSION + '">' +
              '<param name="allowscriptaccess" value="always">' +
              '<embed name="OniconAudio" src="' + Onicon.URL_STATIC + 'js/oniconaudio.swf?_v=' +
              Onicon.VERSION + '" allowscriptaccess="always"></embed>' +
              '</object>';
            var onicon_audio, last_file;
            audio[0].play = function () {
              if (!onicon_audio) {
                last_file = 2;
              } else {
                onicon_audio.playFile(2);
              }
            };
            Onicon.audio = {
              initSWF: function () {
                var audio = this;
                setTimeout(function () {
                  if (window.OniconAudio && window.OniconAudio.playFile) {
                    onicon_audio = window.OniconAudio;
                  } else if (document.OniconAudio) {
                    if (document.OniconAudio.playFile) {
                      onicon_audio = document.OniconAudio;
                    } else if (document.OniconAudio[0] && document.OniconAudio[0].playFile) {
                      onicon_audio = document.OniconAudio[0];
                    }
                  }
                  if (onicon_audio && last_file) {
                    onicon_audio.playFile(last_file);
                    last_file = null;
                  }
                }, 50);
              }
            };
          }
        }());
        Trigger.execute('panel_created');
      },

      YMInsert: function () {
        if (!core.yandex_metrika.already_included && core.yandex_metrika.yandex_metrika_key) {

          try {
            var counter_id = core.yandex_metrika.yandex_metrika_key,
              noscript = document.createElement('noscript');

            core.yandex_metrika.already_included = true;
            noscript.innerHTML = '<div><img src="//mc.yandex.ru/watch/' + counter_id + '" style="position:absolute; left:-9999px;"></div>';

            document.body.appendChild(noscript);
          } catch (e) {
          }


          try {
            (function (d, w, c) {
              (w[c] = w[c] || []).push(function () {
                try {
                  w['yaCounter' + counter_id] = new Ya.Metrika({
                    id: counter_id,
                    clickmap: true,
                    trackLinks: true,
                    accurateTrackBounce: true,
                    trackHash: true,
                    webvisor: true
                    // Совместная уживаемость с клиенскими метриками
                    // params: window.yaParams || {}
                  });
                } catch (e) {
                }
              });

              var n = d.getElementsByTagName("script")[0],
                s = d.createElement("script"),
                f = function () {
                  n.parentNode.insertBefore(s, n);
                };
              s.type = "text/javascript";
              s.async = true;
              s.src = (d.location.protocol == "https:" ? "https:" : "http:") + "//mc.yandex.ru/metrika/watch.js";

              if (w.opera == "[object Opera]") {
                d.addEventListener("DOMContentLoaded", f, false);
              } else {
                f();
              }
            })(document, window, "yandex_metrika_callbacks");
          } catch (e) {
          }
        }
      },

      /**
       * Инициализирует возможность ресайзить окошко консультанта
       */
      panelResizeInit: function () {
        var resize_state = null;
        var resizer = core.getById('resizer');
        Dom.attachEvent('mousedown', function (e) {
          resize_state = {
            mouse_x: e.clientX,
            mouse_y: e.clientY,
            is_right: core.panel_dim.pos_x === 'right',
            is_bottom: core.panel_dim.pos_y === 'bottom'
          };
          e.preventDefault && e.preventDefault();
          return false;
        }, resizer);

        Dom.attachEvent('mouseup', function () {
          if (resize_state) {
            core.saveDimForIsolatedWindow();
          }
          resize_state = false;
        });

        Dom.attachEvent('mousemove', function (e) {
          if (resize_state) {
            // вычисляем смещение мышки
            var dx = e.clientX - resize_state.mouse_x, dy = e.clientY - resize_state.mouse_y;
            // сохраняем новые координаты, иначе изменение размеров будет НЕ линейным, а взрывным
            resize_state.mouse_x = e.clientX;
            resize_state.mouse_y = e.clientY;

            // если при ресайзе значение ширины будет меньше минимального - игнорируем такой ресайз
            if (core.panel_dim.width + dx < core.panel_dim_limits.min_width) {
              dx = 0;
            }
            // если при ресайзе значение высоты будет меньше минимального - игнорируем такой ресайз
            if (core.panel_dim.height + dy < core.panel_dim_limits.min_height) {
              dy = 0;
            }

            // если при ресайзе будет попытка "выползти за край" - игнорируем
            if (resize_state.is_right && core.panel_dim.margin_x - dx < 0) {
              dx = 0;
            }
            // аналогично для высоты
            if (resize_state.is_bottom && core.panel_dim.margin_y - dy < 0) {
              dy = 0;
            }

            // на значения смещения изменяем линейные размеры окошка
            core.panel_dim.width += dx;
            core.panel_dim.height += dy;

            // если окошко прицеплено к правому краю, то оно начнет расти "влево", следовательно его надо сдвинуть вправо
            // на значение переменщения с инвертированным знаком
            if (resize_state.is_right) {
              core.panel_dim.margin_x -= dx;
            }

            // аналогично по вертикали
            if (resize_state.is_bottom) {
              core.panel_dim.margin_y -= dy;
            }

            // Применяем новые значения для панельки чата
            core.applyPanelDim(true);
            core.scrollBar.update();

            if (e.preventDefault) {
              e.preventDefault();
            }
            return false;
          }
        });
      },

      /**
       * Подогнать окно консультанта под размеры окна (если размеры окна внезапно стали меньше чем консультант)
       * Автоматически выполняет "перерисовку", т.е. не только производит перерасчет, но и перерисовку
       */
      fitPanelToWindow: function () {
        var panel = core.getById('panel');
        var document_height = Dom.documentHeight();
        var document_width = Dom.documentWidth();

        // Если высота окна меньше, чем панелька оникона
        if (document_height < panel.offsetHeight) {
          // И меньше чем минимально допустимая высота
          if (document_height < core.panel_dim_limits.min_height + 186) {
            // То делаем минимальную, тут мы уже ничем помочь не можем
            core.panel_dim.height = core.panel_dim_limits.min_height;
          } else {
            // Иначе делаем высоту равную высоте окна браузера
            core.panel_dim.height = document_height - 186;
          }
        }

        // Аналогично для ширины
        if (document_width < panel.offsetWidth) {
          // И меньше чем минимально допустимая высота
          if (document_width < core.panel_dim_limits.min_width) {
            // То делаем минимальную, тут мы уже ничем помочь не можем
            core.panel_dim.width = core.panel_dim_limits.min_width;
          } else {
            // Иначе делаем ширину равную высоте окна браузера
            core.panel_dim.width = document_width;
          }
        }
        core.applyPanelDim();
      },

      closeWindow: function () {
        window.close();
      },

      closeWidget: function () {
        core.getById('widget-area').style.display = "none";
      },

      /**
       * Сделать окно консультанта указанной ширины
       * @param width
       */
      setPanelWidth: function (width) {
        width = width || core.panel_dim.width || core.panel_dim_default.width;
        width = width < core.panel_dim_limits.min_width ? core.panel_dim_limits.min_width : width;
        core.getById('panel').style.width = parseInt(width) + 'px';
      },

      calcPanelHeight: function () {
        var height = -10;
        var elements = Dom.elementChildren(core.getById('offline-form'));
        for (var i = 0; i < elements.length; i++) {
          if (Dom.hasClass(elements[i], 'onicon_chat-vertical-scroll')) return;
          height += elements[i].offsetHeight;

          var style = elements[i].currentStyle || window.getComputedStyle(elements[i]);

          height += parseInt(style.marginBottom);
          height += parseInt(style.marginTop);
        }

        return height < Dom.documentHeight() ? height + 20 : Dom.documentHeight() - 60;
      },

      /**
       * Сделать окно консультанта указанной высоты, именно все окно, не надо думать сколько там занимает контентная область
       * @param height
       */
      setPanelHeight: function (height) {
        if (core.current_state == core.STATE_OFFLINE) {
          if (core.offline_active_state == 'history') {
            core.getById('dim-dependent-area').style.height = height ? height + 'px' : core.panel_dim_limits.height + 'px';
          } else {
            core.getById('dim-dependent-area').style.height = height ? height + 'px' : core.calcPanelHeight() + 'px';
          }
        } else {
          core.getById('dim-dependent-area').style.height = height ? height + 'px' : core.panel_dim_limits.height + 'px';
        }
      },

      setBookmarkImage: function (bookmark) {
        var inf = core.site_info;
        bookmark.src = (core.current_state == core.STATE_ONLINE ? inf.bookmark_image_online : inf.bookmark_image_offline);
      },

      rePositionCallback: function () {
        var inf = core.site_info,
          panel_width = core.getById('onicon-bookmark-helper').offsetWidth / 2,
          panel_height = core.getById('onicon-bookmark-helper').offsetHeight;

        if (inf.bookmark_image_online && inf.bookmark_image_offline) {
          panel_width = Math.round(panel_width * 0.7);
        }

        if (core.viewCallbackButton) {
          Dom.positionBookmark(
            core.getById('float_button_wrap'),
            inf.bookmark_position_x,
            inf.bookmark_position_y,
            parseInt(inf.bookmark_margin_x) + panel_width + 10,
            parseInt(inf.bookmark_margin_y) + 70 + panel_height,
            inf.bookmark_orientation,
            true
          )
        }
        !(Navigator.isMobile && !core.site_info.mobile_enabled) && core.showBlock('float_button_wrap');
      },

      // Коллбек на ресайз окна браузера
      resize_callback: function () {
        core.fitPanelToWindow();
        Dom.positionBookmark(
          core.getById(core.bookmark_id),
          core.site_info.bookmark_position_x,
          core.site_info.bookmark_position_y,
          core.site_info.bookmark_margin_x,
          core.site_info.bookmark_margin_y,
          core.site_info.bookmark_orientation
        );

        // callback_button.style.top = (Dom.cssInt(callback_button, 'top') + window.pageYOffset * Dom.getDocumentZoom()) + 'px';
        // callback_button.style.left = (Dom.cssInt(callback_button, 'left') + window.pageXOffset) *Dom.getDocumentZoom() + 'px';
        var callback_button = core.getById('float_button_wrap');
        if (callback_button != null) {
          if (!Onicon.LOADER_PARAMS.wix)
            callback_button.style.zoom = Dom.getDocumentZoom();
        }

        if (core.getById('float_button_wrap')) Dom.callbackOnCenter(core.getById(core.bookmark_id), core.getById('float_button_wrap'));
      },

      drawBookmark: function (title_text) {
        if (core.isolated) {
          return;
        }
        if (!core.getById(core.bookmark_id)) {
          var inf = core.site_info, bookmark;

          if (inf.bookmark_image_online && inf.bookmark_image_offline) {
            bookmark = document.createElement('img');	//DOM элемент закладочка
            bookmark.id = core.createId(core.bookmark_id);
            core.setBookmarkImage(bookmark);
            bookmark.style.cursor = 'pointer';
            bookmark.style.background = 'none';
            bookmark.style.boxShadow = 'none';
            bookmark.style.padding = 0;
            bookmark.style.verticalAlign = 'inherit';
            bookmark.className = 'onicon_chat-hint-wrap onicon_chat-hint-wrap_is-hidden';

            bookmark.onload = function () {
              Onicon.trigger.execute('img_created');
            };

            inf.bookmark_orientation = 'horizontal';

            document.body.appendChild(bookmark);

            Onicon.log('[core.visitor:drawBookmark] image loaded');
            Onicon.lib('dom').positionBookmark(bookmark, inf.bookmark_position_x, inf.bookmark_position_y,
              inf.bookmark_margin_x, inf.bookmark_margin_y, inf.bookmark_orientation);

            Trigger.bind('img_created', function () {
              Onicon.core.rePositionCallback();
            });

            Onicon.buttonAnimation.start('#' + core.createId('roll-animation'));

          } else {

            bookmark = document.createElement('div');	//DOM элемент закладочка
            bookmark.style.visibility = 'hidden';
            bookmark.id = core.createId(core.bookmark_id);
            bookmark.className = 'onicon_chat-hint-wrap onicon_chat-hint-wrap_is-hidden';
            bookmark.innerHTML =
              '<div class="onicon_chat-hint-label" style="background-color: ' + core.site_info.colors[0] + '">' +
              '<div class="onicon_chat-hint-icon">' +
              '<svg class="onicon-logo" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">' +
              '<path  fill="#FFFFFF" fill-opacity="0.33"  d="M12.3,34.3L33.9,12C31.1,9.2,27.3,7.5,23,7.5C14.5,7.5,7.5,14.5,7.5,23C7.5,27.5,9.4,31.5,12.3,34.3z"/>' +
              '<path  fill="#DCD8D2" d="M42.2,33.6l5,11.1c0.4,0.8-0.4,1.6-1.2,1.4L33.4,42L42.2,33.6z"/>' +
              '<path  fill="#B9B6B0" d="M43.4,36.2l-1.1-2.6L33.4,42l3.3,1.1C39.3,41.3,41.6,38.9,43.4,36.2L43.4,36.2z"/>' +
              '<circle fill="#ECEBE8" cx="23.1" cy="23.1" r="8.9"/>' +
              '<path fill="#ECEBE8" d="M22.9,0.2C10.4,0.2,0.2,10.4,0.2,22.9c0,12.6,10.2,22.7,22.7,22.7s22.7-10.2,22.7-22.7C45.7,10.4,35.5,0.2,22.9,0.2z M23,38.4c-8.5,0-15.3-6.9-15.3-15.3S14.6,7.7,23,7.7c4.2,0,7.9,1.7,10.7,4.4c2.8,2.8,4.6,6.7,4.6,11C38.4,31.5,31.5,38.4,23,38.4z"/>' +
              '<path  fill-opacity="0.29" d="M15.3,27.3c-0.7-1.4-1.4-2.6-1.4-4.2c0-5.2,3.9-9.4,9.1-9.4c2.5,0,4.6,1.3,6.3,3l0,0c-1.6-1.6-3.8-2.6-6.2-2.6c-4.9,0-8.9,4-8.9,8.9C14.3,24.6,14.6,26.1,15.3,27.3L15.3,27.3z"/>' +
              '</svg>' +
              '</div>' +
              '<span>' + title_text + '</span>' +
              '</div>';

            document.body.appendChild(bookmark);

            Onicon.lib('dom').positionBookmark(core.getById(core.bookmark_id), inf.bookmark_position_x,
              inf.bookmark_position_y, inf.bookmark_margin_x, inf.bookmark_margin_y, inf.bookmark_orientation);

            core.rePositionCallback();

            Onicon.buttonAnimation.start('#' + core.createId('roll-animation'));
          }

          bookmark.style.zIndex = 99999;

          bookmark.onclick = function () {
            // Если мобилка то открыть в новом окне!
            if (core.isolated_mode || Onicon.navigator.isMobile) {
              core.openIsolatedWindow();
            } else {
              core.switchPanels();
              Trigger.execute('bookmark-click');
            }
          };

          bookmark.onmouseover = function () {
            Dom.addClass(this, 'onicon_chat-hover');
            if (this.children[0]) {
              this.children[0].style.background = Colors.darken(core.site_info.colors[0], 20);
            }
          };

          bookmark.onmouseout = function () {
            Dom.removeClass(this, 'onicon_chat-hover');
            if (this.children[0]) {
              this.children[0].style.background = core.site_info.colors[0];
            }
          };

          core.checkVisibility() && Dom.removeClass(bookmark, 'onicon_chat-hint-wrap_is-hidden');
        }
      },

      drawButton: function () {
        if (core.isolated) {
          return;
        }
        var site_button = document.getElementById('onicon_site_button'), res;

        if (site_button) {
          res = /([\d\w\.\+%]+)_(on|off)\.(png|jpg|jpeg|gif|bmp)/.exec(site_button.src);
          if (res && res[1] !== undefined) {
            core.site_button_id = res[1];

            site_button.style.cursor = 'pointer';
            site_button.title = core.main_title;

            site_button.onclick = function () {
              if (core.isolated_mode) {
                core.openIsolatedWindow();
              } else {
                core.panel_show_allow = true;
                core.switchPanels();
              }
            };

            var gif_buttons = ['145', '146', '147', '148', '149', '150', '151'];
            if (gif_buttons.indexOf(site_button.getAttribute('data-id')) != -1) {
              site_button.src = site_button.src.replace('_off.png', '_off.gif');
            }

            if (core.current_state === core.STATE_OFFLINE) {
              if (gif_buttons.indexOf(site_button.getAttribute('data-id')) != -1) {
                site_button.src = site_button.src.replace('_on.png', '_off.gif');
              } else {
                site_button.src = site_button.src.replace('_on.', '_off.');
              }
            } else if (core.current_state === core.STATE_ONLINE) {
              if (gif_buttons.indexOf(site_button.getAttribute('data-id')) != -1) {
                site_button.src = site_button.src.replace('_off.gif', '_on.png');
              } else {
                site_button.src = site_button.src.replace('_off.', '_on.');
              }
            }
          }
        }

        core.site_buttons = [];
        var site_buttons = document.getElementsByTagName('img');
        if (site_buttons && site_buttons.length && !(Onicon.navigator.isMobile && !Onicon.core.site_info.mobile_enabled)) {
          for (var s = 0; s < site_buttons.length; s++) {
            var img = site_buttons[s];
            if (img && img.className && img.className.match('onicon_site_button')) {
              res = /([\d\w\.\+%]+)_(on|off)\.(png|jpg|jpeg|gif|bmp)/.exec(img.src);
              if (res && res[1]) {
                core.site_buttons.push(img);
                img.style.cursor = 'pointer';
                img.onclick = function () {
                  if (core.isolated_mode) {
                    core.openIsolatedWindow();
                  } else {
                    core.panel_show_allow = true;
                    core.switchPanels();
                  }
                }
              }
            }
          }
        }
      },

      setButtonsState: function () {
        var insite_button = document.getElementById('onicon_site_button');
        var gif_buttons = ['145', '146', '147', '148', '149', '150', '151'];
        if (insite_button) {
          if (core.current_state == core.STATE_ONLINE) {
            if (gif_buttons.indexOf(insite_button.getAttribute('data-id')) != -1) {
              insite_button.src = insite_button.src.replace('_off.gif', '_on.png');
            } else {
              insite_button.src = insite_button.src.replace('_off.', '_on.');
            }
          } else {
            if (gif_buttons.indexOf(insite_button.getAttribute('data-id')) != -1) {
              insite_button.src = insite_button.src.replace('_on.png', '_off.gif');
            } else {
              insite_button.src = insite_button.src.replace('_on.', '_off.');
            }
          }
        }


        if (core.site_buttons && core.site_buttons.length) {
          for (var s = 0; s < core.site_buttons.length; s++) {
            var img = core.site_buttons[s];
            if (img && img.src) {
              if (core.current_state == core.STATE_ONLINE) {
                img.src = img.src.replace('_off.', '_on.');
              } else {
                img.src = img.src.replace('_on.', '_off.');
              }
            }
          }
        }
      },

      saveDimForIsolatedWindow: function () {
        var panel = core.getById('panel');
        if (panel && !core.isHided('panel')) {
          Cookie.set(
            Onicon.COOKIE_PREFIX + 'isolated_size',
            panel.offsetLeft + ',' + panel.offsetTop + ',' + panel.offsetWidth + ',' + panel.offsetHeight,
            Onicon.other_cookie_ttl
          );
        }
      },

      openIsolatedWindow: function () {
        if (core.isolated_sign) {
          var panel = core.getById('panel');
          var left, top, width, height;

          var dim = Cookie.get(Onicon.COOKIE_PREFIX + 'isolated_size');
          dim = dim ? dim.split(',') : [0, 0, 0, 0];

          var server_param = (Onicon.LOADER_PARAMS.server ? '&server=' + Onicon.LOADER_PARAMS.server : '');
          left = (window.screenLeft || 0) + (+dim[0] || 0);
          top = (window.screenTop || 0) + 80 + (+dim[1] || 0);
          width = +dim[2] || 280;
          height = +dim[3] || 556;

          core.isolated_window = window.open(
            Onicon.URL_STATIC + 'chat.html?_v' + Onicon.VERSION + '&user_id=' + core.user_id +
            '&user_hash=' + core.user_hash + '&site_id=' + Onicon.LOADER_PARAMS.site_id +
            '&isolated_sign=' + core.isolated_sign + server_param +
            '&send_btn=' + core.checkButtonState('control-enter', true) +
            '&audio_btn=' + core.checkButtonState('control-sound', true) +
            '&lang=' + (Onicon.LOADER_PARAMS.lang ? Onicon.LOADER_PARAMS.lang : '') +
            '&srv=' + (Onicon.LOADER_PARAMS.srv ? Onicon.LOADER_PARAMS.srv : 1),
            'onicon_chat_' + Onicon.LOADER_PARAMS.site_id,
            'menubar=no,location=no,status=no,toolbar=no,resizable=yes,height=' + height + ',width=' + width + ',left=' + left + ',top=' + top,
            true
          );
          Cookie.remove(Onicon.COOKIE_PREFIX + 'chat_opened');
          core.isolated_window.focus();
        } else {
          Onicon.error('Isolated sign error');
        }
      },

      updateOperator: function (operator) {
        if (core.getById(core.panel_id) && !core.online_disabled) {
          if (operator || core.channels.chat.operators.length) {
            var op_id = core.active_operator ? core.active_operator : 0;
            var op = (operator ? operator : core.channels.chat.operators[op_id]);
            core.getById('operator-photo').src = "https://cp.onicon.ru" + '/images/avatars/' + op._id + '_' +
              op.gender + '.png?' + Math.random();
            core.setPanelHeader(op.last_name + ' ' + op.first_name);
            core.showBlock('operator-avatar');
            if (!core.isolated) {
              Dom.addClass(core.getById('avatar-frame'), 'onicon_chat-avatar-frame-big');
            }
          } else {
            core.setPanelHeader(core.current_state == core.STATE_ONLINE ? core.site_info.panel_title : core.site_info.panel_title_offline);
            core.hideBlock('operator-avatar');
            Dom.removeClass(core.getById('avatar-frame'), 'onicon_chat-avatar-frame-big');
          }
          core.applyPanelDim();
        }
      },

      switchPanels: function () {
        if (!core.isolated_mode) {
          var panel = core.getById(core.panel_id),
            bookmark = core.getById(core.bookmark_id),
            dom = Onicon.dom;
          if (Dom.hasClass(panel, 'onicon_chat_is-hidden')) {
            Onicon.log('[core:switchPanels] panel is hided, show panel');
            Cookie.set(Onicon.COOKIE_PREFIX + 'chat_opened', true, Onicon.panel_opened_cookie_ttl);
            core.showPanel();
            //Trigger.execute(Trigger.EV_V_PANEL_SHOW);

            Trigger.execute('panel-open');

          } else {
            Onicon.log('[core:switchPanels] panel is visible, show bookmark');
            Cookie.remove(Onicon.COOKIE_PREFIX + 'chat_opened');
            core.showBookmark();
            Trigger.execute(Trigger.EV_V_PANEL_HIDE);

            Trigger.execute('panel-close');

          }
          //core.rePositionCallback();
        }
      },


      switchOfflinePanelState: function (switch_to_messages) {
        var dom = Onicon.lib('dom'),
          offline_switch_form = core.getById('offline-switch-form'),
          offline_switch_history = core.getById('offline-switch-history'),
          message_area = core.getById('message-area-wrap'),
          form_area = core.getById('offline-form-area');

        if (!core.online_disabled) {
          switch_to_messages = switch_to_messages || false;

          if (switch_to_messages) {
            message_area.style.display = 'block';
            form_area.style.display = 'none';
            core.scrollMessageArea();
            Dom.removeClass(offline_switch_form, 'selected');
            Dom.addClass(offline_switch_history, 'selected');
          } else {
            message_area.style.display = 'none';
            form_area.style.display = 'block';
            Dom.removeClass(offline_switch_history, 'selected');
            Dom.addClass(offline_switch_form, 'selected');
          }
        } else {
          message_area.style.display = 'none';
          form_area.style.display = 'block';
        }

        var default_set = core.site_info.default_widget_set ? core.site_info.default_widget_set : 'sample-standart';
        Onicon.widgets.showWidget(default_set, '', true);
      },

      checkVisibility: function () {
        if (!core.isolated && core.isolated_mode) {
          Onicon.log('[core:checkVisibility] isolated mode active and this one is not isolated, hide');
          return false;
        }

        if (Onicon.navigator.isMobile && !Onicon.core.site_info.mobile_enabled) {
          Onicon.log('[core:checkVisibility] Mobile Detected and mobile_enabled set to 0, hide');
          Trigger.execute('sas_disable');
          return false;
        }

        // TOTAL Mobile SAS Disable
        if (Onicon.navigator.isMobile) {
          if (Onicon.LOADER_PARAMS.site_id != "4f168aa21ab7883c38000003") {
            Trigger.execute('sas_disable');
          }
        }

        // если всегда отображать то все понятно
        if (core.visibility_mode == 1) {
          Onicon.log('[core:checkVisibility] always visible');
          return true;
        }

        if (core.visibility_mode == 2 && core.channels.site.operators.length) {
          Onicon.log('[core:checkVisibility] no messages, mode 2, has operators');
          return true;
        }

        Trigger.execute('sas_disable');
        return false;
      },

      showPanel: function () {

        var panel = core.getById(core.panel_id),
          bookmark = core.getById(core.bookmark_id);


        //вычислим высоту панели и подгоним iframe
        var p_height = panel.offsetHeight;
        if (Onicon.LOADER_PARAMS.wix && Wix != undefined) {
          Wix.resizeWindow(300, p_height + 100);
        }


        if (core.checkVisibility() || core.panel_show_allow) {
          Onicon.log('[core:showPanel] ok');
          core.applyPanelDim();
          core.setPanelHeight();
          // Не успевает отрендерить HTML в хроме, поэтому вводим небольшую задержку
          setTimeout(function () {
            core.scrollMessageArea();
            core.scrollOfflineArea();
            core.applyPanelDim();
          }, 100);

          Dom.removeClass(panel, 'onicon_chat_is-hidden');
          panel.style.visibility = 'visible';
          !core.isolated && Dom.addClass(bookmark, 'onicon_chat-hint-wrap_is-hidden');
          core.hideBlock('float_button_wrap');

        } else {
          Onicon.log('[core:showPanel] false');
        }
        Trigger.execute(Trigger.EV_V_PANEL_SHOW);

      },

      showBookmark: function () {
        var panel = core.getById(core.panel_id),
          bookmark = core.getById(core.bookmark_id);

        if (core.checkVisibility()) {
          Onicon.log('[core:showBookmark] ok');
          bookmark.style.visibility = 'visible';
          Dom.removeClass(bookmark, 'onicon_chat-hint-wrap_is-hidden');
          !(Navigator.isMobile && !core.site_info.mobile_enabled) && core.showBlock('float_button_wrap');
        } else {
          Onicon.log('[core:showBookmark] false');
        }

        //!(Navigator.isMobile && !core.site_info.mobile_enabled) && core.showBlock('float_button_wrap');
        core.rePositionCallback();
        Dom.addClass(panel, 'onicon_chat_is-hidden');

        if (Onicon.LOADER_PARAMS.wix && Wix != undefined) {
          Wix.resizeWindow(300, 300);
        }
      },

      useVisibility: function (block_id) {
        return (block_id === core.panel_id || block_id === core.bookmark_id);
      },

      isHided: function (block_id) {
        var block = core.getById(block_id);
        if (block) {
          return (core.useVisibility(block_id) ? block.style.visibility === 'hidden' : block.style.display === 'none');
        }
        Onicon.log('Can\'t test block hiding ' + block_id);
        return null;
      },

      isShown: function (block_id) {
        return !core.isHided(block_id);
      },

      showBlock: function (block_id) {
        var block = core.getById(block_id);
        if (block) {
          if (core.useVisibility(block_id)) {
            block.style.visibility = 'visible';
          } else {
            block.style.display = 'block';
          }
          Onicon.log('Show block ' + block_id);
        } else {
          Onicon.log('Can\'t show block ' + block_id);
        }
      },

      hideBlock: function (block_id) {
        var block = core.getById(block_id);
        if (block) {
          if (core.useVisibility(block_id)) {
            block.style.visibility = 'hidden';
          } else {
            block.style.display = 'none';
          }
          Onicon.log('Hide block ' + block_id);
        } else {
          Onicon.log('Can\'t hide block ' + block_id);
        }
      },


      initiateButtonState: function (config) {
        if (!config.id) {
          Onicon.error('[core] Button id must be set');
          return;
        }
        var b = core.getById(config.id),
          dom = Onicon.lib('dom'),
          cookie_name = Onicon.COOKIE_PREFIX + 'button_state_' + config.id,
          cookie_value = Cookie.get(cookie_name),
          default_state, titles, use_cookie, state;

        if (!b) {
          Onicon.error('Button %s not found', config.id);
          return;
        }

        default_state = config.default_state;
        titles = config.titles;
        use_cookie = config.use_cookie;

        typeof titles !== 'object' && (titles = {});
        !titles.enabled && (titles.enabled = '');
        !titles.disabled && (titles.disabled = '');

        state = use_cookie && cookie_value !== null ? +cookie_value : default_state;

        if (state) {
          Dom.removeClass(b, 'disabled');
          b.title = titles.enabled;
          config.enabled_cb && config.enabled_cb.call(b);
        } else {
          Dom.addClass(b, 'disabled');
          b.title = titles.disabled;
          config.disabled_cb && config.disabled_cb.call(b);
        }

        Dom.attachEvent('click', function () {
          if (!Dom.hasClass(b, 'disabled')) {
            Dom.addClass(b, 'disabled');
            b.title = titles.disabled;

            config.disabled_cb && config.disabled_cb.call(b);
            use_cookie && Cookie.set(cookie_name, 0, Onicon.other_cookie_ttl);
          } else {
            Dom.removeClass(b, 'disabled');
            b.title = titles.enabled;

            config.enabled_cb && config.enabled_cb.call(b);
            use_cookie && Cookie.set(cookie_name, 1, Onicon.other_cookie_ttl);
          }
        }, b);
      },


      checkButtonState: function (id, return_as_int) {
        var element = this.getById(id);
        if (!element) {
          Onicon.error('[core] Button %s not found', id);
          return null;
        }
        var res = !Onicon.lib('dom').hasClass(element, 'disabled');
        if (return_as_int) {
          return res ? 1 : 0;
        } else {
          return res;
        }
      },


      notify: function () {
        if (core.SOUNDS_ON && (core.isolated || !core.isolated_mode)) {
          var notify = core.getById('audio-notify');
          if (notify) {
            try {
              notify.play && notify.play();
            } catch (e) {
              Onicon.log(e);
            }
          }
        }
      },

      resaveMessagesData: function () {
        Onicon.log('[core.messages:resaveMessagesData] Resave messages data to cache');
        var autosends_log = {};

        var messages = core.channels.chat.messages;
        var last_message_id = messages.length ? (messages[messages.length - 1]._id) : null;

        Dom.foreach(core, messages, function (i, message) {
          if (message.autosend) {
            autosends_log[message.autosend] = {
              autosend: message.autosend,
              sender_id: message.sender_id,
              sender_type: message.sender_type,
              post_date: message.post_date
            };
          }
        });

        core.autosends_log = autosends_log;

        LocalStorage.set('onicon_history:' + core.user_id, {
          last_message_id: last_message_id,
          messages_history: messages,
          autosends_log: autosends_log
        });
      },

      removeMessagesData: function () {
        core.autosends_log = {};
        core.last_message_id = null;
        core.messages_history = [];

        LocalStorage.remove('onicon_history:' + core.user_id);
      },

      addChannel: function (channel) {
        channel.users = {length: 0};
        channel.operators = {length: 0};

        if (channel.owner_type === Onicon.protocol.TYPE_SITE) {
          core.channels['site'] = channel;
        } else {
          if (!channel.messages.length && core.messages_history.length) {
            Onicon.log('[core.messages:addChannel] Use cached messages data');
            channel.messages = core.messages_history;
          }
          core.channels['chat'] = channel;
          core.resaveMessagesData();
        }

        Transport.send({
          flag: Onicon.protocol.CLIENT_CODE_LIST_CHANNEL,
          channel_id: channel.channel_id
        });
      },


      /**
       * Добавляет только операторов
       * @param c_id channel id
       * @param u_id user id
       * @param u_type user type
       * @param u_info user info
       */
      userComeToChannel: function (c_id, u_id, u_type, u_info) {
        u_info = u_info || {_id: u_id};

        var c = core.channels, p = Onicon.protocol;
        c = c.site.channel_id === c_id ? c.site : (c.chat.channel_id === c_id ? c.chat : 0);
        if (c && !c.operators[u_id]) {
          c.operators[u_id] = u_info;
          c.operators[c.operators.length++] = c.operators[u_id];
          if (c.owner_type === p.TYPE_SITE) {
            core.siteOperatorsStatus();
            Trigger.execute(Trigger.EV_V_OPERATOR_COME_TO_SITE, u_id, u_info);
          } else if (c.owner_type === p.TYPE_VISITOR) {

            if (c.operators.length == 1) {
              core.active_operator = u_id;
            }

            core.chatOperatorsStatus();
            Trigger.execute(Trigger.EV_V_OPERATOR_COME_TO_CHAT, u_id, u_info);
          }
        }
      },


      /**
       * Удаляет оператора из каналов
       * @param c_id channel id
       * @param u_id user id
       * @param u_type user type
       */
      userLeaveChannel: function (c_id, u_id, u_type, ch_id) {
        var p = Onicon.protocol, c = core.channels;
        c = c.site.channel_id === c_id ? c.site : (c.chat.channel_id === c_id ? c.chat : 0);

        if (c) {
          if (c.operators[u_id]) {
            delete c.operators[c.operators[u_id].index];
            delete c.operators[u_id];
            c.operators.length--;
          }

          if (core.active_operator == u_id) {

            var real_length = Object.keys(c.operators).length;

            core.active_operator = Object.keys(c.operators)[Math.max(0, real_length - 1)];
            //Onicon.error(c.operators);
            //Onicon.error(Math.max(0, real_length-1));

          }

          if (c.owner_type === p.TYPE_VISITOR) {
            core.chatOperatorsStatus();
            Trigger.execute(Trigger.EV_V_OPERATOR_LEAVE_CHAT, u_id);
          } else if (c.owner_type === p.TYPE_SITE && u_type === p.TYPE_OPERATOR) {
            core.siteOperatorsStatus();
            Trigger.execute(Trigger.EV_V_OPERATOR_LEAVE_SITE, u_id);
          }
        }

        core.applyPanelDim();

        var cookie_review = Cookie.get(Onicon.COOKIE_PREFIX + 'oper_review');
        var user_messages = document.getElementsByClassName('onicon_chat-sendTypeUser');
        var oper_messages = document.getElementsByClassName('onicon_chat-sendTypeOperator');

        //if(user_messages.length > 0 && oper_messages.length > 0 && cookie_review == undefined) {
        //    var sys_dialog = core.getById('system-dialog');
        //    sys_dialog.style.display = "block";
        //    setTimeout(function() {
        //        sys_dialog.style.display = "none";
        //    }, 10000);
        //
        //    if(u_id != undefined && u_type == 2 && ch_id != undefined) {
        //        core.channel_id = ch_id;
        //    }
        //    Cookie.set(Onicon.COOKIE_PREFIX + 'oper_review', 1);
        //}

      },


      operatorRaiting: function (rating) {
        var sys_dialog = core.getById('system-dialog');
        sys_dialog.style.display = "none";

        $.ajax({
          url: Onicon.URL_STATIC + '/index.php?mode=operator&act=writeReview',
          type: "POST",
          crossDomain: true,
          data: {
            channel_id: core.channel_id,
            rating: rating
          },
          cache: false,
          success: function () {

          }
        });
      },


      // Вызывается 1 раз, только во время инициализации
      usersInChannel: function (channel_id, users, operators) {
        for (var i in operators) {
          if (operators.hasOwnProperty(i)) {
            Onicon.log(operators[i]);
            core.userComeToChannel(channel_id, operators[i]._id, operators[i].user_type, operators[i]);
          }
        }
        if (!--core.auth_channels) {
          core.initChat();
          Trigger.execute(Trigger.EV_WORKING);
          if (!core.ev_run) {
            core.ev_run = true;
            Trigger.execute(Trigger.EV_WORKING_ONCE);
          }
        }
      },


      getUserInChannelByIdAndType: function (channel_id, user_id, user_type) {
        var type = user_type === core.TYPE_VISITOR ? 'users' : 'operators',
          ch = core.channels[channel_id];
        return ch && ch[type][user_id] ? ch[type][user_id] : false;
      },


      makeMessage: function (message) {
        var is_my_message = message.sender_id == core.user_id;
        var d = new Date(DateSync.correct(message.post_date) * 1000),
          dom = Onicon.lib('dom'),
          user_info = core.locale.you, user;
        if (message.sender_id !== core.user_id) {
          user = core.getUserInChannelByIdAndType(message.channel_id, message.sender_id, message.sender_type);
          user_info = user ? user.last_name + ' ' + user.first_name : (message.sender_name && message.sender_name !== ''
            ? message.sender_name : 'Оператор');


        }

        var roistat = Cookie.get('roistat_visit');

        return '<div  style="' + (is_my_message ? '' : 'background-color: ' + core.site_info.colors[1] + '; border-color: ' + core.site_info.colors[0]) + '" class="onicon_chat-message onicon_chat-sendType' + (is_my_message ? 'User' : 'Operator') + '">' +
          '<div class="onicon_chat-message-datetime">' +
          '<span style="color: ' + core.site_info.colors[0] + '">' + (Dom.addDigits(d.getDate()) + '.' +
          Dom.addDigits(d.getMonth() + 1) + '.' + d.getFullYear().toString().substr(2, 2) + '</span><span style="color: ' + core.site_info.colors[0] + '">' +
          Dom.addDigits(d.getHours()) + ':' + Dom.addDigits(d.getMinutes())) + '</span>' +
          '</div>' +
          '<div class="onicon_chat-message-senderName" style="color: ' + core.site_info.colors[0] + '">' + user_info + '</div>' +
          '<div class="onicon_chat-message-text">' + Formatter.format(message.message, roistat ? {addGetParam: {roistat_visit: roistat}} : false) + '</div>' +
          (is_my_message ? '' : '<div class="onicon_chat-message-arrow" style="border-bottom: 7px solid ' + core.site_info.colors[1] + ';"></div>') +
          '</div>';
      },

      drawMessage: function (message) {
        var correct_date = new Date(DateSync.correct(message.post_date) * 1000);
        var now = new Date();

        if ((now.getTime() - correct_date.getTime()) <= 864e5) {
          if (message.subsystem == 'ia') {
            var ia_data = message.message.split('\n');
            core.systemMessage('Запущена карта знаний по теме: ' + ia_data[1]);
          } else if (message.subsystem == 'widget') {
            var widget_data = message.message.split('\n');
          } else {
            core.getById('message-area').innerHTML += core.makeMessage(message);
          }
        }

        var message_div = document.getElementsByClassName('onicon_chat-message-text');

        if (message_div.length > 0) {
          var message_height = parseInt(message_div[message_div.length - 1].offsetHeight);
          var dim_height = parseInt(core.getById("dim-dependent-area").style.height);
          var dim = core.panel_dim;
          var panel = core.getById('panel');

          if ((message_height + dim_height) < core.panel_dim_default.max_height) {
            core.setPanelHeight(message_height + dim_height + 45);
            Dom.positionFixed(panel, dim.pos_x, dim.pos_y, dim.margin_x, dim.margin_y);
          }
        }

        // Скрытые режимы
        core.panel_show_allow = true;
        if (core.isHided(core.panel_id) && core.isHided(core.bookmark_id)) {
          core.showBlock(core.panel_id)
        }

        core.scrollMessageArea();
      },

      sendMessage: function () {
        var area = core.getById('input-area'),
          text = area.value.replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/^\s+|\s+$/g, '');

        if (core.sending_lock_release_timeout === null) {
          if (text.length) {
            core.sendChatMessage(text);
            core.sending_lock_release_timeout = window.setTimeout(function () {
              core.releaseSending();
            }, core.RELEASE_SENDING_TIME);
          }
        } else {
          core.systemMessage(core.locale.msg_chat_message_sending_in_progress, 'sending');
        }
      },

      sendChatMessage: function (text) {
        if (window.ONICON_FIRST_MESSAGE_PREFIX && !SessionStorage.get('megagroup_onicon_' + core.user_id + '_first_message')) {
          text = ONICON_FIRST_MESSAGE_PREFIX + text;
          SessionStorage.set('megagroup_onicon_' + core.user_id + '_first_message', (+new Date()).toString());
        }

        Transport.send({
          flag: Onicon.protocol.CLIENT_CODE_SEND_CHAT_MESSAGE,
          channel_id: core.channels.chat.channel_id,
          message: text
        });

        Trigger.execute('chat-sendMessage', text);
      },

      messageProcessed: function () {
        if (core.sending_lock_release_timeout !== null) {
          clearTimeout(core.sending_lock_release_timeout);
          core.sending_lock_release_timeout = null;
          var area = core.getById('input-area');
          area.value = '';
          area.style.background = 'transparent';
          area.focus();
        }
      },


      releaseSending: function () {
        core.sending_lock_release_timeout = null;
        core.systemMessage(core.locale.msg_chat_message_send_error);
      },


      /**
       * @param [message]
       * @param ident
       * @returns {null}
       */
      systemMessage: function (message, ident) {
        var msg_id = null;
        if (core.getById(core.panel_id)) {
          msg_id = 'chat-message-' + (ident ? ident : core.inc++);
          Onicon.lib('dom').removeElement(core.getById(msg_id));

          core.getById('message-area').innerHTML += '<div class="onicon_chat-dialogue-notification" id="' +
            core.createId(msg_id) + '"><div class="onicon_chat-notification-icon"></div><div class="onicon_chat-notification-text">' + message + '</div></div>';
          core.scrollMessageArea();
        }
        return msg_id;

      },

      offlineFormMessage: function (message) {
        var msg = '<div class="onicon_chat-message-text">' + Formatter.format(message.message) + '</div>'
        var autosend_countainer = core.getById('widget-offline-header-msg');
        if (autosend_countainer) {
          autosend_countainer.innerHTML = msg;
        }
        core.setPanelHeight();
      },

      chatMessageCame: function (message) {
        Trigger.execute('onmessage', message);
        // Если это не авторассылка, выставляем соответствующий флаг
        if (!message.autosend) {
          core.has_manual_messages = true;
          Dom.addClass(core.getById('offline-mode-nav'), 'onicon_chat-full-mode')
        }
        // Если это сообщение от кого-то кроме самого себя
        if (message.sender_id !== core.user_id) {
          var sas_message = Onicon.sas.getSas(message.autosend);
          var sound_on = true;

          if (!message.autosend) {
            Trigger.execute('chat-incomingMessage', message.message);
          } else {
            Trigger.execute('chat-incomingAutosend', {
              id: message.autosend,
              text: message.message,
              created: (new Date()).getTime() / 1e3
            });
          }

          // Если сообщение является авторассылкой
          if (!message.subsystem && message.autosend) {
            //var sas_message = Onicon.sas.getSas(message.autosend);
            if (sas_message) {
              if (core.current_state == core.STATE_OFFLINE) {
                core.site_info.offline_message = message.message;
                core.offlineFormMessage(message);
              }

              if (sas_message.rules['sound_off']) {
                var sound_split = sas_message.rules['sound_off'].split(';');
                if (sound_split.length === 1) {
                  sound_on = false;
                } else {
                  var h = (new Date()).getHours();
                  if (h >= +sound_split[1] && h < +sound_split[2]) {
                    sound_on = false;
                  }
                }
              }

              sound_on && core.notify();
              core.showPanel();

              var ex = /([^\s]+)(?:[\s]*)(.*)/.exec(message.sender_name);
              if (core.current_state === core.STATE_ONLINE) {
                core.updateOperator({
                  _id: message.sender_id,
                  gender: message.gender,
                  first_name: ex[2],
                  last_name: ex[1]
                });
              }
            }
          } else {
            if (message.subsystem == "widget" && core.getById('widget-area')) {
              if (core.current_state == core.STATE_ONLINE) {
                core.getById('widget-area').style.display = "block";
                core.getById('widget-close').onclick = core.closeWidget;
              }
              sound_on = !sas_message.rules['sound_off'];
            }

            if (message.message.indexOf('callback') == -1) {
              Dom.addClass(core.getById(core.panel_id), 'onicon_chat_is-hidden');
              core.showPanel();
            }

            sound_on && core.notify();
          }

          if (!core.TEXTAREA_FOCUSED && core.isolated) {
            blinker.enable('* Новое сообщение *');
          }

          if (core.isHided(core.panel_id)) {
            if (core.current_state != core.STATE_ONLINE) {
              core.switchPanels();
            }
          }
        }

        var mess = core.getById('chat-message-ask');
        if (mess) {
          mess.parentNode.removeChild(mess);
        }

        mess = core.getById('chat-message-operators-state');
        if (mess) {
          mess.parentNode.removeChild(mess);
        }

        core.channels.chat.messages.push(message);
        core.resaveMessagesData();

        if (sas_message) {
          core.userTyping();
          setTimeout(function () {
            core.drawMessage(message);
            core.clearTyping();
          }, 3000)
        } else {
          core.drawMessage(message);
          core.clearTyping();
        }
      },

      scrollMessageArea: function () {
        var scroll_area = core.getById('scroll-message-area');
        scroll_area.scrollTop = scroll_area.scrollHeight;
      },

      scrollOfflineArea: function () {
        var scroll_area = core.getById('offline-form');
        scroll_area.scrollTop = scroll_area.scrollHeight;
      },

      /**
       * Fires when site channel operator come or leave
       */
      siteOperatorsStatus: function () {
        core.stateSwitcher();
      },


      /**
       * Fires when chat channel operator come or leave
       */
      chatOperatorsStatus: function () {
        core.updateOperator();
        core.stateSwitcher();
      },


      /**
       * Fires from siteOperatorsStatus() and chatOperatorsStatus() to change panel state
       */
      stateSwitcher: function () {
        if (!core.channels.chat.operators.length && !core.channels.site.operators.length) {
          if (core.current_state === core.STATE_ONLINE) {
            core.switchPanelState(core.STATE_OFFLINE);

          }
        } else {
          if (core.current_state === core.STATE_OFFLINE) {
            core.switchPanelState(core.STATE_ONLINE);
            core.systemMessage(core.locale.msg_operators_state_changed_to_online, 'operators-state');
          }
        }
      },

      setPanelHeader: function (text) {

        Onicon.log('[header] Update Header: ' + text);

        var on = core.getById('operator-name'),
          ot = core.getById('offline-title');
        if (on) on.innerHTML = '<strong>' + text + '</strong>';
        if (ot) ot.innerHTML = '<strong>' + text + '</strong>';
      },

      setBookmarkText: function (text) {
        var bm = core.getById('bookmark');
        if (bm && bm.children[0] && bm.children[0].children[1]) {
          var bk = bm.children[0].children[1];

          if (Navigator.isIE) {
            bk.innerText = text;
          } else {
            bk.textContent = text;
          }
        }
      },

      /**
       * Set panel state as online-active(true)/online-not-active(false)
       */
      switchPanelState: function (state) {
        var panel = core.getById(core.panel_id),
          bookmark = core.getById(core.bookmark_id),
          dom = Onicon.lib('dom');

        Trigger.execute('chat-stateChange', state);

        if (panel) {
          if (state === core.STATE_ONLINE) {
            core.current_state = state;
            Onicon.log('Switch to online');
            core.setPanelHeader(core.site_info.panel_title);
            core.setBookmarkText(core.site_info.panel_title);
            core.showBlock('message-area-wrap');
            core.getById('offline-form-area').style.display = 'none';
            Dom.removeClass(panel, 'onicon_chat-offline');
            Dom.addClass(panel, 'onicon_chat-online');
            Trigger.execute('state_change', 'online');
          } else {
            Onicon.log('Switch to offline');
            core.current_state = state;
            core.setPanelHeader(core.site_info.panel_title_offline);
            core.setBookmarkText(core.site_info.panel_title_offline);
            core.hideBlock('operator-area');
            Dom.removeClass(panel, 'onicon_chat-online');
            Dom.addClass(panel, 'onicon_chat-offline');
            core.channels.chat.operators = {length: 0};
            core.channels.site.operators = {length: 0};
            core.switchOfflinePanelState(false);
            Trigger.execute('state_change', 'offline');

            // Перезаполняем виджетом по умолчанию
            //if (core.first_switch) {
            //   core.first_switch = false;
            //} else {
            //   // Onicon.error('RefillWidget');
            //   Onicon.widgets.showWidget(core.site_info.default_widget_set);
            //}
            core.hideBlock('widget-area');
          }
          core.setButtonsState();
          core.setBookmarkImage(bookmark);
        }
        core.applyPanelDim();
      },


      userTyping: function (user_id, user_type, channel_id) {
        core.showBlock('status');

        if (core.typing_display_timeout !== null) {
          clearTimeout(core.typing_display_timeout);
          core.typing_display_timeout = null;
        }

        core.typing_display_timeout = setTimeout(core.clearTyping, Onicon.TYPING_TIME + 500);
      },


      clearTyping: function () {
        clearTimeout(core.typing_display_timeout);
        core.typing_display_timeout = null;
        core.hideBlock('status');
      },


      LF_Process_Submit: function (current) {

        if (current.ONICON_LF_SUBMITED) {
          Onicon.log('[core.live-forms] break process submit ', current);
          return true;
        }

        Onicon.log('[core.live-forms] run process submit ', current);
        current.ONICON_LF_SUBMITED = true;

        Onicon.core.liveFormsSave(current);
        Onicon.core.liveFormsSend();

      },

      liveFormsApply: function () {

        if (this.live_forms_applied) {
          return;
        }
        this.live_forms_applied = true;

        init(window);
        findFrames(document);

        observe(function (node) {
          if (node.tagName === 'IFRAME') {
            initFrame(node);
            return;
          }
          findFrames(node);
        });

        function findFrames(context) {
          [].forEach.call(context.querySelectorAll('iframe'), initFrame);
        }

        function initFrame(node) {
          var flag;
          try {
            flag = has(node, 'contentWindow.document.addEventListener');
          } catch (e) {
            flag = false;
          }
          if (flag) {
            node.addEventListener('load', function () {
              init(node.contentWindow);
            });
            init(node.contentWindow);
          }
        }

        function init(context) {
          var key = 'onicon_live_forms_applied';
          try {
            if (context[key]) {
              return;
            }
          } catch (e) {
            return;
          }

          context[key] = true;
          context.addEventListener('submit', function (e) {
            var current = e.target;
            Onicon.log('[core.live-forms] run process submit ', current);
            core.liveFormsSave(current);
            core.liveFormsSend();
          }, true);
        }

        function observe(fn) {
          if (!window.MutationObserver) {
            return;
          }
          const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
              [].forEach.call(mutation.addedNodes, function (node) {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  fn(node);
                }
              });
            });
          });
          observer.observe(document, {childList: true, subtree: true});
        }

        function has(obj, path) {
          var parts = path.split('.');
          for (var i = 0, len = parts.length; i < len; i++) {
            var key = parts[i];
            if (key in obj) {
              obj = obj[key];
              continue;
            }
            return false;
          }
          return true;
        }
      },

      liveFormsSave: function (form) {
        Onicon.log('[core.live-forms] saving form:', form);

        var fields_names = '', j;
        var fields = {};
        var inputs = form.getElementsByTagName('input');
        var textareas = form.getElementsByTagName('textarea');
        var selects = form.getElementsByTagName('select');
        var indexes = {
          k: 10
        };

        var clear = function (text) {
          text = encodeURIComponent(text);
          text = text.replace(/[^a-zA-Z0-9%_]/i, '');
          return text;
        };

        var _addField = function (field) {
          if (typeof(field) !== 'object' || !field.name) {
            return;
          }

          var name = field.name;
          var idx = null;
          var match;
          while (match = name.match(/(.+?)\[\]/)) {
            if (indexes[match[1]] != undefined) {
              indexes[match[1]]++;
            } else {
              indexes[match[1]] = 0;
            }
            idx = indexes[match[1]];
            name = name.replace(/\[\]/, '[' + idx + ']')
          }

          var value = null;

          switch (field.type) {
            case 'checkbox':
              value = (field.checked ? true : false);
              break;
            case 'radio':
              value = (field.checked ? field.value : false);
              break;
            case 'select':
            case 'select-multiple':
              if (field.multiple) {
                var options = field.getElementsByTagName('option');
                var selected_options = [];
                for (var z = 0; z < options.length; z++) {
                  if (!options[z].selected) continue;
                  selected_options.push(options[z].value);
                }
                value = selected_options.join(';');
              } else {
                value = field.value;
              }
              break;
            case 'text':
              if (core.canCallback && $(field).data('validator') == 'phone') {
                Onicon.rpc.call({
                  ctrl: "vox",
                  action: "makeCall",
                  params: {
                    "tPhone": field.value.replace("+", ""),
                    "rule": 679,
                    "text": core.site_info.callback.welcome_text
                  },
                  success: function (data) {
                    Onicon.core.processVoxCallback(data);
                  }
                });
              }
              value = field.value;
              break;
            default:
              value = field.value;
              break;
          }

          name = clear(name);
          if (name) {
            fields_names += name;
            if (field.type == 'radio') {
              if (!fields[name]) {
                fields[name] = value;
              }
            } else {
              fields[name] = value;
            }
          }
        };

        for (j = 0; j < inputs.length; j++) {
          if (inputs[j].type && inputs[j].type.toString().match(/password/i)) continue;
          _addField(inputs[j]);
        }
        for (j = 0; j < textareas.length; j++) {
          _addField(textareas[j]);
        }
        for (j = 0; j < selects.length; j++) {
          _addField(selects[j]);
        }

        var name = clear(Onicon.LOADER_PARAMS.site_id + '_'
          + (form.name && (typeof(form.name) == 'string') ? form.name : 'noName') + '_'
          + (form.id && (typeof(form.id) == 'string') ? form.id : 'noId') + '_'
          + (form.action && (typeof(form.action) == 'string') ? form.action : 'noAction') + '_'
          + (form.method && (typeof(form.method) == 'string') ? form.method.toLowerCase() : 'noMethod') + '_'
          + fields_names);

        if (Onicon.core.live_forms_config && Onicon.core.live_forms_config[name] && Onicon.core.live_forms_config[name].ignore) {
          return; // exit without saving and submiting form
        }

        var saved_form = {
          name: name,
          fields: fields,
          location: core.docInfo.location,
          referrer: core.docInfo.referer,
          title: core.docInfo.title,
          token: (new Date().getTime() + Math.random())
        };

        Onicon.log('[core.live-forms] saved to storage:', saved_form);

        SessionStorage.set('onicon_saved_live_form', JSON.stringify(saved_form));
      },


      liveFormsSend: function () {
        var form_data = SessionStorage.get('onicon_saved_live_form'), i;
        if (form_data) {
          var form = JSON.parse(form_data);
          Onicon.log('[core.live-forms] send: found form data: ', form);

          var filters = {
            allow: [],
            deny: []
          };

          if (Onicon.core.live_forms_config && Onicon.core.live_forms_config[form.name]) {
            var conf = Onicon.core.live_forms_config[form.name];
            if (conf.allow) {
              filters.allow = conf.allow;
            }
            if (conf.deny) {
              filters.allow = conf.deny;
            }
          }

          var validated = null;
          if (filters) {
            if (filters['deny'] && filters['deny'].length) {
              validated = true;

              for (i = 0; i < filters['deny'].length; i++) {
                if (document.body.innerHTML.match(new RegExp(filters['deny'][i], 'i'))) {
                  validated = false;
                  break;
                }
              }
            } else if (filters['allow'] && filters['allow'].length) {
              validated = false;

              for (i = 0; i < filters['allow'].length; i++) {
                if (document.body.innerHTML.match(new RegExp(filters['allow'][i], 'i'))) {
                  validated = true;
                  break;
                }
              }
            } else {
              validated = true;
            }
          } else {
            validated = true;
          }

          if (validated) {
            Onicon.log('[core.live-forms] sending form: ', form);
            Transport.send({
              flag: Onicon.protocol.CLIENT_CODE_SEND_LIVE_FORM,
              location: form.location,
              referrer: form.referrer,
              title: form.title,
              form: form,
              token: form.token
            });
          } else {
            Onicon.log('[core.live-forms] sorry, can\'t form: ', form);
          }
        } else {
          Onicon.log('[core.live-forms] send: not form data');
        }
      },

      liveFormsDelete: function (delete_case) {
        Onicon.log('[core.live-forms] live form deleted in case of ' + (delete_case ? 'success' : 'error'));
        SessionStorage.del('onicon_saved_live_form');
      }
    };

  var blinker = {
    saved_title: null,
    last_link_id: null,

    enable: function (title_text) {
      var blinking_not_available = function (code) {
        clearInterval(core.favicon_blinker_interval);
        core.favicon_blinker_interval = false;
        Onicon.log('[core > enableFaviconBlinker:lambda] Blinking is not available on this page: ' + code);
      };

      if (core.favicon_blinker_interval === null) {
        Onicon.log('[core > enableFaviconBlinker] Creating favicon blinker');
        (function (text) {
          blinker.saved_title = document.title;
          core.favicon_blinker_interval = window.setInterval(function () {
            var link_tags = document.getElementsByTagName('link');
            var founded = false;
            for (var i in link_tags) {
              var tag = link_tags[i];
              if (tag.rel && tag.rel.indexOf('icon') != -1) {
                var match = tag.href.match(/onicon_(green|red)\.ico/i)
                if (match) {
                  founded = true;
                  var new_filename = (match[0] == 'onicon_green.ico' ? 'onicon_red.ico' : 'onicon_green.ico');
                  //Onicon.log('[core > enableFaviconBlinker:lambda] Favicon blink ' + new_filename);
                  var link = document.createElement('link');
                  link.type = 'image/x-icon';
                  link.rel = 'shortcut icon';
                  link.href = Onicon.URL_STATIC + '/images/admin/' + new_filename;
                  link.id = 'onicon_favicon';
                  document.getElementsByTagName('head')[0].removeChild(tag);
                  document.getElementsByTagName('head')[0].appendChild(link);

                  if (text) {
                    document.title = (document.title == blinker.saved_title ? text : blinker.saved_title);
                  }
                  break;
                } else {
                  blinking_not_available(1);
                }
              }
            }
            if (!founded) {
              blinking_not_available(2);
            }
          }, 500);
        })(title_text);
      } else if (core.favicon_blinker_interval === false) {
        Onicon.log('[core > enableFaviconBlinker] Favicon blinker is not available on this page');
      } else {
        Onicon.log('[core > enableFaviconBlinker] Favicon blinker already working');
      }
    },

    disable: function () {
      if (core.favicon_blinker_interval) {
        clearInterval(core.favicon_blinker_interval);
        core.favicon_blinker_interval = null;
        document.title = blinker.saved_title;

        var link = document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = Onicon.URL_STATIC + '/images/admin/onicon_green.ico';
        link.id = 'onicon_favicon';
        document.getElementsByTagName('head')[0].removeChild(
          document.getElementById('onicon_favicon')
        );
        document.getElementsByTagName('head')[0].appendChild(link);

        Onicon.log('[core > disableFaviconBlinker] Interval cleared');
      } else {
        Onicon.log('[core > disableFaviconBlinker] Nothing to clear');
      }
    }
  };


  var button_animation = {
    start: function (animation_id) {
      var Scene, animation,
        bind = function (fn, me) {
          return function () {
            return fn.apply(me, arguments);
          };
        };

      Scene = (function () {
        function Scene(screen_id) {
          var fps;
          this.screen_id = screen_id;
          this.loop = bind(this.loop, this);
          fps = 25;
          this.screen = $(this.screen_id);
          this.then = Date.now();
          this.interval = 1000 / fps;
          this.loop();
        }

        Scene.prototype.loop = function () {
          var delta, now;
          requestAnimationFrame(this.loop);
          now = Date.now();
          delta = now - this.then;
          if (delta > this.interval) {
            this.then = now - (delta % this.interval);
            return this.draw();
          }
        };

        Scene.prototype.draw = function () {
          var bpx;
          bpx = this.screen.css('background-position-x');
          return this.screen.css('background-position-x', parseInt(bpx) - 50);
        };

        return Scene;

      })();
      animation = new Scene(animation_id);
    }
  };

  Onicon.lib('core', core, true);
  Onicon.lib('blinker', blinker, true);
})();
